<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex flex-wrap flex-wrap align-items-center justify-content-between mb-4">
                    <div>
                        <h4 class="mb-3">{{ title }}</h4>
                        <p class="mb-0">{{ desc1 }}<br> {{ desc2 }}</p>
                    </div>
                    <div class="d-flex flex-column">
                        <b-button variant="primary pl-5 pr-5" class="mt-2 mr-1" @click="collectGrowthDb()"
                            v-if="showlist">로켓그로스 상품DB 업데이트</b-button>
                        <b-button variant="outline-info pl-3 pr-3" class="mt-2 mr-1" @click="showVendorNameModal"
                            v-if="showlist">허용 스토어 설정</b-button>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <img v-if="showspinner" style="max-width:100%;"
                    :src="require('../../../assets/images/small/spinner.gif')">
                <div v-if="showspinner1" class="d-flex justify-content-center">
                    <div><img style="max-width:10%;"
                            :src="require('../../../assets/images/small/loading.gif')">{{ loadingtext }}</div>
                </div>
            </div>

            <div class="col-lg-12" v-if="showlist">
                <div class="p-3">
                    <div class="row d-flex justify-content-between">
                        <div>
                            <b-button variant="outline-primary" size="sm" class="mb-1 mr-1" @click="showtotal">
                                전체 <b-badge variant="primary" class="ml-1">{{ total }}</b-badge>
                            </b-button>
                            <b-button variant="outline-secondary" size="sm" class="mb-1 mr-1" @click="showProductIdChanged" v-b-tooltip.html="productIdChangedTooltip">
                                노출ID변경<b-badge variant="secondary" class="ml-1">{{ 노출ID변경 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-danger" size="sm" class="mb-1 mr-1" @click="showMatching" v-b-tooltip.html="otherSellersTooltip">
                                타사매칭<b-badge variant="danger" class="ml-1">{{ 타사매칭 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-secondary" size="sm" class="mb-1 mr-1" @click="showa">
                                아이템루저<b-badge variant="secondary" class="ml-1">{{ 아이템루저 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-danger" size="sm" class="mb-1 mr-1" @click="showSaleSuspended">
                                판매중지<b-badge variant="danger" class="ml-1">{{ 판매중지 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-danger" size="sm" class="mb-1 mr-1" @click="showSoldOut">
                                품절<b-badge variant="danger" class="ml-1">{{ 품절 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-danger" size="sm" class="mb-1 mr-1" @click="showb">
                                뱃지없음<b-badge variant="danger" class="ml-1">{{ 뱃지없음 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-success" size="sm" class="mb-1 mr-1" @click="showf">
                                반품<b-badge variant="success" class="ml-1">{{ 반품정보있음 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-primary" size="sm" class="mb-1 mr-1" @click="showg">
                                번들<b-badge variant="primary" class="ml-1">{{ 번들정보있음 }}</b-badge>
                            </b-button>
                            <!-- <b-button variant="outline-success" size="sm" class="mb-1 mr-1" @click="showc">
                            구매정보있음<b-badge variant="success" class="ml-1">{{구매정보있음}}</b-badge>
                            </b-button> -->
                            <b-button variant="outline-secondary" size="sm" class="mb-1 mr-1" @click="showd">
                                구매정보없음<b-badge variant="secondary" class="ml-1">{{ 구매정보없음 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-success" size="sm" class="mb-1 mr-1" @click="showe">
                                매입정보없음<b-badge variant="success" class="ml-1">{{ 매입정보없음 }}</b-badge>
                            </b-button>
                            
                        </div>
                        <div>
                            <!-- <button type="button" class="btn btn-primary mr-3" @click="search(true)">재검색</button> -->
                            <b-button variant="outline-success" size="sm" class="mb-1 mr-1"
                                @click="excelDownFunc">상품DB 다운로드</b-button>
                            <b-button variant="outline-secondary" size="sm" class="mb-1 mr-1"
                                @click="delManageItems">숨김</b-button>
                            <b-button variant="outline-danger" size="sm" class="mb-1 mr-1" v-b-modal.addManage
                                @click="importHideProducts">숨김상품
                                <b-badge variant="danger" class="ml-1" v-if="searchProducts.length">{{
                                    searchProducts.length }}</b-badge>
                            </b-button>
                            <b-button variant="outline-danger" size="sm" class="mb-1 mr-1"
                                @click="openImportInfoModal">매입정보 관리</b-button>
                            <!-- <button type="button" class="btn btn-secondary mr-2 mb-3" @click="collectGrowthDb(true)">로켓그로스 상품DB 전체수집</button> -->
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-12" v-if="showlist">
                <!-- 판매장부에서 매입가 입력하러 넘어온 경우 -->
                <div v-if="noPurchasePriceNotice" class="alert alert-warning d-flex align-items-center py-2 mb-2">
                    <i class="fas fa-tags mr-2"></i>
                    <div>
                        <strong>{{ noPurchasePriceNotice }}</strong>
                        <small class="d-block text-muted">
                            매입가를 넣으면 판매장부의 총이익에 바로 반영됩니다.
                        </small>
                    </div>
                    <div class="flex-grow-1"></div>
                    <b-button size="sm" variant="outline-secondary" @click="clearNoPurchasePriceFilter">
                        전체 보기
                    </b-button>
                </div>

                <div class="d-flex justify-content-start mb-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitchsss"
                            v-model="showReturnProducts">
                        <label class="custom-control-label" for="customSwitchsss">반품상품보기</label>
                    </div>
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitchBundle"
                            v-model="showBundleProducts">
                        <label class="custom-control-label" for="customSwitchBundle">번들상품보기</label>
                    </div>
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitchCoupangHidden"
                            v-model="showCoupangHidden">
                        <label class="custom-control-label" for="customSwitchCoupangHidden">쿠팡숨김 상품보기</label>
                    </div>
                </div>
                <CDataTable
                    storage-key="growthdb.1" :headers="headers" :items="productLists" v-model="tableSelectedItem" :show-select="true"
                    :fixedColumns="'상품명'" itemKey="_id" style="margin-bottom: 10px">
                    <template v-slot:상품등급="{ item }">
                        <!-- 최상위 행이 항상 새제품인 건 아니다. 반품등급 상품이 NEW 부모에 흡수되지 못하면
                             수집이 최상위 문서로 보존한다(background.js `_orphanReturns`). skuGrade 로 판정한다. -->
                        <div><a :href="item.link" target="_blank"><b-badge
                                    :variant="item.skuGrade && item.skuGrade !== 'NEW' ? 'secondary' : 'success'">{{
                                        getSkuGradeLabel(item.skuGrade) }}</b-badge></a></div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">
                                <a :href="a.link" target="_blank">
                                    <b-badge variant="secondary">
                                        {{ a.skuGrade == 'PACKAGE_DAMAGED' ? '반품-미개봉' :
                                            a.skuGrade == 'RETURN_BEST' ? '반품-최상' :
                                                a.skuGrade == 'RETURN_GOOD' ? '반품-상' : '반품-중'
                                        }}
                                    </b-badge>
                                </a>
                            </div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">
                                <a :href="a.link" target="_blank">
                                    <b-badge variant="info">번들x{{ a.upBundlingSize || 1 }}</b-badge>
                                </a>
                            </div>
                        </div>
                    </template>
                    <template v-slot:이미지="{ item }">
                        <div class="d-flex align-items-center" v-b-modal="'modalpurchase' + item._id">
                            <img :src="item.imgUrl" class="img-fluid rounded avatar-50 mr-3" alt="image">
                        </div>
                    </template>
                    <template v-slot:상품명="{ item }">
                        <div v-if="item.displayProductName && !item.상품명.replace(/\s/g, '').includes(item.displayProductName.replace(/\s/g, ''))"
                            style="font-size: 11px; color: #888; margin-bottom: 2px;">
                            [노출] {{ item.displayProductName }}
                        </div>
                        <div>{{ item.상품명 }}</div>
                    </template>
                    <template v-slot:productId="{ item }">
                        <div>
                            <span
                                style="cursor: pointer; color: #007bff; text-decoration: underline;"
                                @click="openProductIdHistoryModal(item)"
                            >{{ item.productId }}</span>
                            <span
                                v-if="item.productIdHistory && item.productIdHistory.length > 0"
                                style="margin-left: 4px; color: #dc3545; font-size: 12px;"
                                title="노출ID 변경 이력 있음"
                            >🔄</span>
                        </div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.productId }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.productId }}</div>
                        </div>
                    </template>
                    <template v-slot:vendorItemId="{ item }">
                        <div>{{ item.vendorItemId }}</div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.vendorItemId }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.vendorItemId }}</div>
                        </div>
                    </template>
                    <template v-slot:barcode="{ item }">
                        <div>{{ item.barcode }}</div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.barcode }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.barcode }}</div>
                        </div>
                    </template>

                    <template v-slot:link="{ item }">
                        <div>
                            <a :href="item.link" target="_blank">
                                <b-icon icon="link" scale="2" variant="primary"></b-icon>
                            </a>
                        </div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">
                                <a :href="'https://www.coupang.com/vp/products/' + a.productId + '?vendorItemId=' + a.vendorItemId"
                                    target="_blank">
                                    <b-icon icon="link" scale="2" variant="primary"></b-icon>
                                </a>
                            </div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">
                                <a :href="'https://www.coupang.com/vp/products/' + a.productId + '?vendorItemId=' + a.vendorItemId"
                                    target="_blank">
                                    <b-icon icon="link" scale="2" variant="info"></b-icon>
                                </a>
                            </div>
                        </div>
                    </template>
                    <template v-slot:구매정보="{ item }">
                        <b-icon v-b-modal="'modalpurchase' + item._id" icon="cart-check" scale="2"
                            :variant="classPurchaseInfo(item)"></b-icon>

                        <b-modal :id="'modalpurchase' + item._id" size="xl" title="구매정보" ok-title="저장" cancel-title="취소"
                            @ok="savePurchaseInfo($event, item)" @cancel="cancelPurchaseInfo($event, item)">
                            <div>{{ item.productName }}</div>
                            <div class="row" v-if="showPurchase">
                                <div class="col-12">
                                    <div class="table-responsive">
                                        <table id="datatable" class="table data-table table-striped dataTable">
                                            <thead>
                                                <tr class="ligth ligth-data">
                                                    <th style="min-width:200px;font-size:90%">제품정보</th>
                                                    <th style="font-size:90%">상품매칭</th>
                                                    <th
                                                        style="max-width:300px;overflow:hidden;text-overflow: ellipsis;font-size:90%">
                                                        구매링크</th>
                                                    <th style="font-size:90%">옵션1_중국어</th>
                                                    <th style="font-size:90%">옵션2_중국어</th>
                                                    <th style="font-size:90%">구성수량</th>
                                                    <!-- <th>구매가격</th> -->
                                                    <!-- <th>구매재고</th> -->
                                                    <th style="font-size:90%">기본요청사항</th>

                                                    <th style="font-size:90%">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(list, idx1) in item.구매정보" :key="idx1" class="tableTr">
                                                    <td style="min-width:200px;font-size:90%">
                                                        <div class="d-flex align-items-center">
                                                            <img :src="list.등록이미지"
                                                                class="img-fluid rounded avatar-80 mr-3" alt="image"
                                                                v-if="list.등록이미지">
                                                            <div v-if="list.상품명">
                                                                {{ list.상품명 }}
                                                                <p class="mb-0"><small>{{ list.바코드 }}</small></p>
                                                            </div>
                                                            <div v-else>
                                                                <input type="text" class="form-control"
                                                                    placeholder="상품명입력" v-model="list.상품명init"
                                                                    @change="addProductName(list)">
                                                                <p class="mb-0"><small>{{ list.바코드 }}</small></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style="font-size:90%">
                                                        <div :class="matchclass(list.매칭상태)">{{ list.매칭상태 }}</div>
                                                    </td>
                                                    <td
                                                        style="max-width:300px;overflow:hidden;text-overflow: ellipsis;font-size:90%">
                                                        <div v-if="list.구매링크 !== undefined">
                                                            <a :href="list.구매링크" target="_blank">{{ list.구매링크 }}</a>
                                                            <div v-if="list.showspinner">
                                                                <img style="width:20%;"
                                                                    :src="require('../../../assets/images/small/loading.gif')">
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <input type="text" class="form-control" placeholder="구매링크입력"
                                                                v-model="list.구매링크init"
                                                                @change="matchoption1(item.구매정보, idx1, list.구매링크init)">
                                                        </div>
                                                    </td>
                                                    <td style="font-size:90%">
                                                        <div v-if="list.옵션이미지 !== undefined">
                                                            <img :src="list.옵션이미지"
                                                                class="img-fluid rounded avatar-80 mr-3" alt="image">
                                                        </div>
                                                        <div v-if="list.옵션1_중국어 !== undefined">
                                                            {{ list.옵션1_중국어 }}
                                                        </div>
                                                        <div v-else>
                                                            <b-dropdown menu-class="my-dropdown-class" size="lg"
                                                                variant="link" toggle-class="text-decoration-none"
                                                                no-caret>
                                                                <template #button-content>
                                                                    &#x1f50d;<span class="sr-only">Search</span>
                                                                </template>
                                                                <b-dropdown-item href="#"
                                                                    v-for="a, i in list.상품매칭.옵션1_중국어" :key="i"
                                                                    @click="option1matching(a, list)">
                                                                    <div class="d-flex align-items-center">
                                                                        <img v-if="a.imageUrl.length > 0"
                                                                            :src="a.imageUrl"
                                                                            class="img-fluid rounded avatar-80 mr-3"
                                                                            alt="image">
                                                                        <div>
                                                                            {{ a.name }}
                                                                        </div>
                                                                    </div>
                                                                </b-dropdown-item>
                                                            </b-dropdown>
                                                        </div>
                                                    </td>
                                                    <td style="font-size:90%">
                                                        <div v-if="list.옵션2_중국어 !== undefined">
                                                            {{ list.옵션2_중국어 }}
                                                        </div>
                                                        <div v-else>
                                                            <b-dropdown menu-class="my-dropdown-class" size="lg"
                                                                variant="link" toggle-class="text-decoration-none"
                                                                no-caret>
                                                                <template #button-content>
                                                                    &#x1f50d;<span class="sr-only">Search</span>
                                                                </template>
                                                                <b-dropdown-item href="#"
                                                                    v-for="a, i in list.상품매칭.옵션2_중국어" :key="i"
                                                                    @click="option2matching(a, list)">
                                                                    <div class="d-flex align-items-center">
                                                                        <img v-if="a.imageUrl.length > 0"
                                                                            :src="a.imageUrl"
                                                                            class="img-fluid rounded avatar-80 mr-3"
                                                                            alt="image">
                                                                        <div>
                                                                            {{ a.name }}
                                                                        </div>
                                                                    </div>
                                                                </b-dropdown-item>
                                                            </b-dropdown>
                                                        </div>
                                                    </td>
                                                    <td style="font-size:90%">
                                                        <div v-if="!editQty" @click="editQty = true">
                                                            {{ list.판매구성수량 }}
                                                        </div>
                                                        <div v-else>
                                                            <input type="number" :min="0" class="form-control"
                                                                placeholder="" aria-label="" v-model="list.판매구성수량"
                                                                style="text-align:center;"
                                                                v-b-tooltip.left="'해당 SKU가 2p 구성일 경우에는 2라고 작성해 주세요'"
                                                                @keyup.enter="editQtyEnter" @change="editQty = false">
                                                        </div>
                                                    </td>
                                                    <!-- <td>
                                                        {{list.구매가격}}
                                                        <small>({{list.이전구매가격}})</small>
                                                    </td> -->
                                                    <!-- <td>{{list.구매재고}}</td> -->
                                                    <td style="font-size:90%">
                                                        <div :class="reqclass(list.요청사항)" v-b-modal="'modalreq' + idx1"
                                                            v-if="idx1 == 0">{{ list.요청사항 }}</div>
                                                        <b-modal modal-class="reqpo-modal-scrollable"
                                                            :id="'modalreq' + idx1" size="xl" title="구매요청사항"
                                                            ok-title="요청내용저장" cancel-title="취소"
                                                            @ok="savereq($event, list, idx1)">
                                                            <div class="reqpo-purchase-request-form">
                                                                <div class="row">
                                                                    <!-- Row 1: Items 1-2 -->
                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">1. 구매요청수량
                                                                            </div>
                                                                            <div class="reqpo-input-wrapper">
                                                                                <div class="d-flex align-items-center">
                                                                                    <input type="number" :min="0"
                                                                                        class="form-control text-center"
                                                                                        style="width: 120px;"
                                                                                        v-model="list.구매요청수량"
                                                                                        @keyup.enter="validateQuantity(list)">
                                                                                    <div class="reqpo-stock-info ml-3">
                                                                                        <span
                                                                                            class="reqpo-info-label">최소주문:</span>
                                                                                        <span
                                                                                            class="reqpo-info-value">{{
                                                                                            getMinOrderQuantity(list)
                                                                                            }}개</span>
                                                                                        <span
                                                                                            class="reqpo-separator">/</span>
                                                                                        <span
                                                                                            class="reqpo-info-label">재고:</span>
                                                                                        <span
                                                                                            class="reqpo-info-value">{{
                                                                                            getAvailableStock(list)
                                                                                            }}개</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">2. 판매구성수량
                                                                            </div>
                                                                            <div class="reqpo-input-wrapper">
                                                                                <input type="number" :min="0"
                                                                                    class="form-control"
                                                                                    style="width: 120px;"
                                                                                    v-model="list.판매구성수량"
                                                                                    v-b-tooltip.hover="'해당 SKU가 2p 구성일 경우에는 2라고 작성해 주세요'">
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                    <!-- Row 2: Items 3-4 -->
                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">3. A-B번들
                                                                                묶음구성여부</div>
                                                                            <div class="bundle-options">
                                                                                <div
                                                                                    class="custom-control custom-switch d-inline-block">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'bundleSwitch' + idx1"
                                                                                        v-model="list.묶음구성여부"
                                                                                        @change="confirmBarcode(list)">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'bundleSwitch' + idx1">묶음구성</label>
                                                                                </div>
                                                                                <div v-if="list.묶음구성여부"
                                                                                    class="bundle-count mt-2">
                                                                                    <input type="number" :min="0"
                                                                                        class="form-control"
                                                                                        style="width: 120px;"
                                                                                        placeholder="종류갯수"
                                                                                        v-model="list.묶음구성수량"
                                                                                        v-b-tooltip.hover="'3종의 제품을 묶음 구성하는 경우 3으로 작성'">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">4. 도착지
                                                                            </div>
                                                                            <div class="destination-options">
                                                                                <div class="btn-group w-100">
                                                                                    <button type="button" class="btn"
                                                                                        :class="{ 'btn-primary': list.요청내역.destination === 'coupang', 'btn-outline-primary': list.요청내역.destination !== 'coupang' }"
                                                                                        @click="list.요청내역.destination = 'coupang'">
                                                                                        쿠팡센터
                                                                                    </button>
                                                                                    <button type="button" class="btn"
                                                                                        :class="{ 'btn-primary': list.요청내역.destination === 'customer', 'btn-outline-primary': list.요청내역.destination !== 'customer' }"
                                                                                        @click="list.요청내역.destination = 'customer'">
                                                                                        화주
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <!-- Row 3: Items 5-7 -->
                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">5. 출고형태
                                                                            </div>
                                                                            <div class="export-options">
                                                                                <div
                                                                                    class="custom-control custom-radio mb-2">
                                                                                    <input type="radio"
                                                                                        :id="'exportBox' + idx1"
                                                                                        name="exportType"
                                                                                        class="custom-control-input"
                                                                                        v-model="list.요청내역.exportType"
                                                                                        value="box">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'exportBox' + idx1">
                                                                                        <span
                                                                                            v-if="!list.요청내역.destination || list.요청내역.destination === 'coupang'">
                                                                                            밀크런 택배
                                                                                        </span>
                                                                                        <span v-else>택배</span>
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    class="custom-control custom-radio">
                                                                                    <input type="radio"
                                                                                        :id="'exportPallet' + idx1"
                                                                                        name="exportType"
                                                                                        class="custom-control-input"
                                                                                        v-model="list.요청내역.exportType"
                                                                                        value="pallet">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'exportPallet' + idx1">
                                                                                        <span
                                                                                            v-if="!list.요청내역.destination || list.요청내역.destination === 'coupang'">
                                                                                            밀크런 파렛트 <small
                                                                                                class="reqpo-text-muted">(￦35,000/pallet)</small>
                                                                                        </span>
                                                                                        <span v-else>
                                                                                            파렛트 <small
                                                                                                class="reqpo-text-muted">(￦20,000/pallet)</small>
                                                                                        </span>
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <!-- </div>

                                                                <div class="col-md-6"> -->
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">6. 통관정보
                                                                            </div>
                                                                            <div class="row">
                                                                                <div class="col-12 mb-3">
                                                                                    <div class="form-group">
                                                                                        <label>신고영문명</label>
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) shoes"
                                                                                            v-model="list.신고영문명">
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-12">
                                                                                    <div class="form-group">
                                                                                        <label>HS-CODE</label>
                                                                                        <div class="d-flex">
                                                                                            <input type="text"
                                                                                                class="form-control"
                                                                                                placeholder="예) 6401.10-1000"
                                                                                                v-model="list.HSCODE">
                                                                                            <div
                                                                                                class="w-25 d-flex align-items-center">
                                                                                                <a href="https://www.bandtrass.or.kr/hsnavi.do"
                                                                                                    target="_blank"
                                                                                                    class="btn btn-outline-secondary ml-2">
                                                                                                    검색
                                                                                                </a></div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">7. 통관형태
                                                                            </div>
                                                                            <div class="customs-options">
                                                                                <div class="reqpo-custom-radio-card mb-2"
                                                                                    :class="{ 'active': list.요청내역.customsType === 'integrated' }"
                                                                                    @click="list.요청내역.customsType = 'integrated'">
                                                                                    <div class="reqpo-card-title">
                                                                                        쿠패스통합통관</div>
                                                                                    <div class="reqpo-card-desc">
                                                                                        위안화x280, 검수/포장비용 제외 모든비용 포함
                                                                                    </div>
                                                                                </div>
                                                                                <div class="reqpo-custom-radio-card mb-2"
                                                                                    :class="{ 'active': list.요청내역.customsType === 'client' }"
                                                                                    @click="list.요청내역.customsType = 'client'">
                                                                                    <div class="reqpo-card-title">화주단독통관
                                                                                    </div>
                                                                                    <div class="reqpo-card-desc">
                                                                                        구매대행수수료3%, 자재, 관부가세, 해운비, 통관비,
                                                                                        통관서류 비용 등 별도</div>
                                                                                </div>
                                                                                <div class="reqpo-custom-radio-card"
                                                                                    :class="{ 'active': list.요청내역.customsType === 'kupass' }"
                                                                                    @click="list.요청내역.customsType = 'kupass'">
                                                                                    <div class="reqpo-card-title">
                                                                                        쿠패스단독통관</div>
                                                                                    <div class="reqpo-card-desc">식검제품만
                                                                                        신청가능, 구매대행수수료3%, 자재, 관부가세, 해운비,
                                                                                        통관비, 통관서류 비용 등 별도
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <!-- Full width sections -->
                                                                    <div class="col-md-6">
                                                                        <!-- 검수 및 포장 섹션 -->
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">8. 검수 및 포장
                                                                            </div>
                                                                            <div class="inspection-options">

                                                                                <!-- 패키징 옵션 -->
                                                                                <div v-if="list.요청내역.default"
                                                                                    class="packaging-options mb-3">
                                                                                    <div
                                                                                        class="reqpo-option-title mb-2">
                                                                                        포장 방법 선택:</div>
                                                                                    <div
                                                                                        class="custom-control custom-radio mb-2">
                                                                                        <input type="radio"
                                                                                            :id="'packageAuto' + idx1"
                                                                                            name="packageMethod"
                                                                                            class="custom-control-input"
                                                                                            value="auto"
                                                                                            v-model="packageMethod"
                                                                                            @change="changePackage(list)">
                                                                                        <label
                                                                                            class="custom-control-label"
                                                                                            :for="'packageAuto' + idx1">
                                                                                            포장 방법 위임
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        class="custom-control custom-radio mb-2">
                                                                                        <input type="radio"
                                                                                            :id="'packageNo' + idx1"
                                                                                            name="packageMethod"
                                                                                            class="custom-control-input"
                                                                                            value="noPackage"
                                                                                            v-model="packageMethod"
                                                                                            @change="changePackage(list)">
                                                                                        <label
                                                                                            class="custom-control-label"
                                                                                            :for="'packageNo' + idx1">
                                                                                            재포장 생략
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        class="custom-control custom-radio mb-2">
                                                                                        <input type="radio"
                                                                                            :id="'packageOPP' + idx1"
                                                                                            name="packageMethod"
                                                                                            class="custom-control-input"
                                                                                            value="opp"
                                                                                            v-model="packageMethod"
                                                                                            @change="changePackage(list)">
                                                                                        <label
                                                                                            class="custom-control-label"
                                                                                            :for="'packageOPP' + idx1">
                                                                                            투명 OPP 봉투 포장 (무료)
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        class="custom-control custom-radio">
                                                                                        <input type="radio"
                                                                                            :id="'packageLDPE' + idx1"
                                                                                            name="packageMethod"
                                                                                            class="custom-control-input"
                                                                                            value="LDPE"
                                                                                            v-model="packageMethod"
                                                                                            @change="changePackage(list)">
                                                                                        <label
                                                                                            class="custom-control-label"
                                                                                            :for="'packageLDPE' + idx1">
                                                                                            불투명 LDPE 봉투 포장 (무료)
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div class="reqpo-option-group mb-3">
                                                                                <div
                                                                                    class="custom-control custom-switch">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'defaultCheck' + idx1"
                                                                                        v-model="list.요청내역.default">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'defaultCheck' + idx1">
                                                                                        기본검수/분류/포장/포장자재 (￦200)
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            <!-- 라벨링 옵션 -->
                                                                            <div class="labeling-options mb-3">
                                                                                <div
                                                                                    class="custom-control custom-switch mb-2">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'barcodeCheck' + idx1"
                                                                                        v-model="list.요청내역.barcode"
                                                                                        @change="changeBarcode(list)">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'barcodeCheck' + idx1">
                                                                                        바코드라벨 (Made in China,한글표시사항
                                                                                        기본포함) (￦100)
                                                                                    </label>
                                                                                </div>

                                                                                <div v-if="!list.요청내역.barcode"
                                                                                    class="custom-control custom-switch">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'stickerCheck' + idx1"
                                                                                        v-model="list.요청내역.sticker">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'stickerCheck' + idx1">
                                                                                        원산지스티커 (￦100)
                                                                                    </label>
                                                                                </div>
                                                                            </div>

                                                                            <!-- 추가 작업 옵션 -->
                                                                            <div class="additional-options">
                                                                                <div
                                                                                    class="custom-control custom-switch mb-2">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'maskingCheck' + idx1"
                                                                                        v-model="list.요청내역.masking">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'maskingCheck' + idx1">
                                                                                        중국어 마스킹 (무료)
                                                                                    </label>
                                                                                </div>

                                                                                <div
                                                                                    class="custom-control custom-switch mb-2">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'airpackingCheck' + idx1"
                                                                                        v-model="list.요청내역.airpacking">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'airpackingCheck' + idx1">
                                                                                        에어캡 포장 (실비)
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    class="custom-control custom-switch mb-2">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'sewingCheck' + idx1"
                                                                                        v-model="list.요청내역.sewing">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'sewingCheck' + idx1">
                                                                                        원산지라벨 봉제 (6000원/시간)
                                                                                    </label>
                                                                                    <div class="reqpo-warning-text">* 의류
                                                                                        수입 시 원산지 라벨봉제는 필수 사항입니다.</div>
                                                                                </div>

                                                                                <div
                                                                                    class="custom-control custom-switch mb-2">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'stampCheck' + idx1"
                                                                                        v-model="list.요청내역.stamp">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'stampCheck' + idx1">
                                                                                        원산지 도장 (6000원/시간)
                                                                                    </label>
                                                                                    <div class="reqpo-warning-text">*
                                                                                        신발류 수입 시 제품에 원산지 라벨봉제 또는 원산지 도장은
                                                                                        필수 사항입니다.</div>
                                                                                </div>

                                                                                <div
                                                                                    class="custom-control custom-switch">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'tagCheck' + idx1"
                                                                                        v-model="list.요청내역.tag">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'tagCheck' + idx1">
                                                                                        원산지 택(태그) (6000원/시간)
                                                                                    </label>
                                                                                    <div class="reqpo-warning-text">*
                                                                                        가방류 수입 시 원산지 라벨봉제 또는 원산지 택 표기가
                                                                                        필수 사항입니다.</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    <div class="col-md-6">

                                                                        <!-- 한글표시사항 섹션 -->
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">9. 한글표시사항
                                                                            </div>

                                                                            <!-- 바코드라벨 미부착 시 경고 -->
                                                                            <div v-if="!list.요청내역.barcode"
                                                                                class="reqpo-warning-box mb-3">
                                                                                <div class="warning-content">
                                                                                    <div class="warning-title">※ 바코드라벨을
                                                                                        부착하지 않는 경우,</div>
                                                                                    <div class="reqpo-warning-text"
                                                                                        v-if="list.요청내역.destination === 'coupang'">
                                                                                        쿠팡센터 직납 시 사전에 제품패키지 겉에 반드시 바코드가
                                                                                        부착되거나 새겨져 있어야 합니다.
                                                                                    </div>
                                                                                    <div class="reqpo-warning-text"
                                                                                        v-if="list.요청내역.destination === 'customer'">
                                                                                        반드시 원산지표시가 되어 있어야 합니다.
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <!-- 한글표시사항 입력 폼 -->
                                                                            <div v-if="list.요청내역.barcode"
                                                                                class="korean-label-form">
                                                                                <!-- 바코드 -->
                                                                                <div class="form-group">
                                                                                    <label
                                                                                        class="col-form-label">바코드번호</label>
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) S00012341234"
                                                                                        v-model="list.바코드">
                                                                                    <small class="reqpo-warning-text">*
                                                                                        바코드는 쿠팡에 등록한 바코드번호를
                                                                                        입력해주세요</small>
                                                                                </div>

                                                                                <!-- 제품명 (별도 상단 배치) -->
                                                                                <div class="form-group">
                                                                                    <label>제품명</label>
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) 쿠플러스 예쁜접시, 10인치"
                                                                                        v-model="list.상품명">
                                                                                    <small class="reqpo-warning-text">*
                                                                                        쿠팡에 등록한 상품명 + 옵션명을 같이
                                                                                        입력해주세요</small>
                                                                                </div>

                                                                                <!-- 기타 한글표시사항 -->
                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">수입원/판매원</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 쿠플러스"
                                                                                            v-model="list.한글표시사항['수입원/판매원']">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">제조원</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 중국OEM"
                                                                                            v-model="list.한글표시사항.제조원">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">제조국</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 중국"
                                                                                            v-model="list.한글표시사항.제조국">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">내용량</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 300ml"
                                                                                            v-model="list.한글표시사항.내용량">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">원료명및성분명(재질)</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 도자기제"
                                                                                            v-model="list.한글표시사항['원료명및성분명(재질)']">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">상품유형</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 주방용품"
                                                                                            v-model="list.한글표시사항.상품유형">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">사용시주의사항</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 용도 이외에 사용금지"
                                                                                            v-model="list.한글표시사항.사용시주의사항">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">사용기준</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 14세 이상"
                                                                                            v-model="list.한글표시사항.사용기준">
                                                                                    </div>
                                                                                </div>

                                                                                <!-- KC인증 / 식품용 옵션 -->
                                                                                <div class="form-group row">
                                                                                    <label class="col-sm-3 col-form-label">바코드 옵션</label>
                                                                                    <div class="col-sm-9">
                                                                                        <div class="custom-control custom-switch mb-2">
                                                                                            <input type="checkbox" class="custom-control-input" :id="'kcCheck-g-' + idx1" v-model="list.한글표시사항.kc인증">
                                                                                            <label class="custom-control-label" :for="'kcCheck-g-' + idx1">KC인증마크 표시</label>
                                                                                        </div>
                                                                                        <div class="custom-control custom-switch">
                                                                                            <input type="checkbox" class="custom-control-input" :id="'foodCheck-g-' + idx1" v-model="list.한글표시사항.식품용">
                                                                                            <label class="custom-control-label" :for="'foodCheck-g-' + idx1">식품용 (식품위생법에 의한 한글표시사항)</label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <!-- 기타 표시사항 -->
                                                                                <div class="form-group row">
                                                                                    <label class="col-sm-3 col-form-label">기타</label>
                                                                                    <div class="col-sm-9">
                                                                                        <textarea class="form-control" rows="2" placeholder="기타 표시사항" v-model="list.한글표시사항.custom"></textarea>
                                                                                    </div>
                                                                                </div>

                                                                                <!-- 바코드 출력 버튼 -->
                                                                                <div class="mt-2">
                                                                                    <b-button variant="outline-success" size="sm" @click="printBarcodeFromPurchase(list)">
                                                                                        <i class="ri-printer-line mr-1"></i>바코드 출력
                                                                                    </b-button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-6">

                                                                        <!-- 기존 판매자 협의 금액 섹션 -->
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">10. 기존 판매자
                                                                                협의 금액 (선택)</div>
                                                                            <div class="price-info-form">
                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-4 col-form-label">협의단가(CNY)</label>
                                                                                    <div class="col-sm-8">
                                                                                        <input type="number" :min="0"
                                                                                            class="form-control"
                                                                                            v-model="list.협의단가">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-4 col-form-label">
                                                                                        총금액(CNY)<br>
                                                                                        <small>(중국 내륙배송비 포함 전체
                                                                                            결제금액)</small>
                                                                                    </label>
                                                                                    <div class="col-sm-8">
                                                                                        <input type="number" :min="0"
                                                                                            class="form-control"
                                                                                            v-model="list.협의총금액">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-4 col-form-label">협의1688
                                                                                        ID</label>
                                                                                    <div class="col-sm-8">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            v-model="list.협의ID">
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-6">
                                                                        <!-- 기타요청사항 섹션 -->
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">
                                                                                <div>기타요청사항 - 물류요청사항</div>
                                                                                <small class="reqpo-text-muted ml-3">
                                                                                    (예: 1688제품 겉박스 중국어 있는부분 작업 요청 내용,
                                                                                    실사,
                                                                                    사이즈, 무게, 센터 입고요청, 신발도장, 의류봉제 등,
                                                                                    OPP/LDPE/뽁뽁이 일반검수/정밀검수, 시간이 걸리는 별도의
                                                                                    작업은
                                                                                    6000/시간의 작업비 발생)
                                                                                </small>
                                                                            </div>
                                                                            <textarea class="form-control mt-3" rows="3"
                                                                                v-model="list.요청내역.reqcontent">
                        </textarea>
                                                                        </div>
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">
                                                                                <div>기타요청사항 - 구매요청사항</div>
                                                                            </div>
                                                                            <textarea class="form-control mt-3" rows="3"
                                                                                v-model="list.요청내역.reqcontentPurchase">
                        </textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </b-modal>

                                                    </td>

                                                    <td style="font-size:90%">
                                                        <div class="d-flex justify-content-center list-action">
                                                            <!-- <a class="badge badge-primary mr-2" data-toggle="tooltip" v-b-tooltip.top title="복사" href="javascript:void(0)" @click="copyReq(item.구매정보)">
                                                                <i class="ri-file-copy-line mr-0"></i>
                                                            </a> -->
                                                            <a class="badge bg-success mr-2" data-toggle="tooltip"
                                                                v-b-tooltip.top title="옵션재매칭" href="javascript:void(0)"
                                                                @click="rematching(item.구매정보, list, idx1)">
                                                                <i class="ri-pencil-line mr-0"></i>
                                                            </a>
                                                            <a class="badge badge-secondary mr-2" data-toggle="tooltip"
                                                                v-b-tooltip.top title="Reset" href="javascript:void(0)"
                                                                @click="reset(list)">
                                                                <i class="ri-eye-line mr-0"></i>
                                                            </a>
                                                            <a class="badge bg-warning mr-2" data-toggle="tooltip"
                                                                v-b-tooltip.top title="삭제" href="javascript:void(0)"
                                                                @click="deleteitem(item.구매정보, idx1, item)">
                                                                <i class="ri-delete-bin-line mr-0"></i>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-12 mb-0">
                                    <b-button @click="copyReq(item.구매정보)" variant="outline-primary"
                                        class="text-center">+ 묶음구성추가</b-button>
                                </div>
                            </div>
                        </b-modal>
                    </template>

                    <!-- FILTERED_OUT 은 '정보없음'이 아니라 **팔 수 없는 상태**다. 뱃지·필터와 같은
                         판정식으로 「판매중지」/「품절」을 갈라 보여준다(조치가 정반대라 섞으면 안 된다).
                         근거·교차표는 isSaleSuspended() 주석 참고. -->
                    <template v-slot:winner="{ item }">
                        <b-badge :variant="classWinner(item.winner)">{{ winnerLabel(item) }}</b-badge>
                    </template>
                    <template v-slot:badge="{ item }">
                        <div>{{ item.badge ? 'Y' : 'N' }}</div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.badge ? 'Y' : "N" }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.badge ? 'Y' : "N" }}</div>
                        </div>
                    </template>
                    <template v-slot:수수료.sizeName="{ item }">
                        <div v-b-modal="'size' + item._id">
                            {{ item.수수료?.sizeName == 'MINI' ? '극소형' :
                                item.수수료?.sizeName == 'SMALL' ? '소형' :
                                    item.수수료?.sizeName == 'MEDIUM' ? '중형' :
                                        item.수수료?.sizeName == 'LARGE1' ? '대형1' :
                                            item.수수료?.sizeName == 'LARGE2' ? '대형2' : '특대형'
                            }}
                        </div>

                        <b-modal :id="'size' + item._id" size="sm" title="등록사이즈" ok-only>
                            <div class="row">
                                <div class="col-md-12 mt-4 mb-1">
                                    <h6>1. 사이즈 (mm)</h6>
                                    <div class="custom-control-inline ml-3" v-if="item.skuInfo">
                                        {{ item.skuInfo.width }} x {{ item.skuInfo.length }} x {{ item.skuInfo.height }}
                                    </div>
                                    <h6>2. 무게 (g)</h6>
                                    <div class="custom-control-inline ml-3" v-if="item.skuInfo">
                                        {{ item.skuInfo.weight }}
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                    </template>
                    <template v-slot:commission="{ item }">
                        <div v-b-modal="'commision' + item._id">
                            {{ parseInt(item.commission * 1.1) }}
                        </div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">
                                {{ parseInt(a.commission * 1.1) }}
                            </div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">
                                {{ parseInt(a.commission * 1.1) }}
                            </div>
                        </div>

                        <b-modal :id="'commision' + item._id" size="md" title="수수료내역" ok-only>
                            <div class="row">
                                <div class="col-md-12 mt-4 mb-1">
                                    <h6 class="text-primary"
                                        v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                                        {{ getSkuGradeLabel(item.skuGrade) }}</h6>
                                    <h6>1. 풀필먼트수수료(배송비)</h6>
                                    <div class="custom-control-inline ml-3">
                                        {{ Math.round(item.수수료?.배송비 * 1.1) }}
                                    </div>
                                    <h6>2. 입출고수수료</h6>
                                    <div class="custom-control-inline ml-3">
                                        {{ Math.round(item.수수료?.입출고비 * 1.1) }}
                                    </div>
                                    <h6>3. 판매수수료(판매수수료율)</h6>
                                    <div class="custom-control-inline ml-3">
                                        {{ Math.round(item.수수료?.판매수수료 * 1.1) }}({{ Math.round(item.수수료?.판매수수료율 * 1.1 * 100) / 100 }}%)
                                    </div>
                                </div>
                            </div>
                            <div class="row"
                                v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                                <div class="col-md-12 mt-4 mb-1" v-for="a, i in item.returnProducts" :key="i">
                                    <h6 class="text-secondary">{{ a.skuGrade == 'PACKAGE_DAMAGED' ? '반품-미개봉' :
                                        a.skuGrade == 'RETURN_BEST' ? '반품-최상' :
                                            a.skuGrade == 'RETURN_GOOD' ? '반품-상' : '반품-중'
                                    }}</h6>
                                    <h6>1. 풀필먼트수수료(배송비)</h6>
                                    <div class="custom-control-inline ml-3">
                                        {{ Math.round(a.수수료?.배송비 * 1.1) }}
                                    </div>
                                    <h6>2. 입출고수수료</h6>
                                    <div class="custom-control-inline ml-3">
                                        {{ Math.round(a.수수료?.입출고비 * 1.1) }}
                                    </div>
                                    <h6>3. 판매수수료(판매수수료율)</h6>
                                    <div class="custom-control-inline ml-3">
                                        {{ Math.round(a.수수료?.판매수수료 * 1.1) }}({{ Math.round(a.수수료?.판매수수료율 * 1.1 * 100) / 100 }}%)
                                    </div>
                                </div>
                            </div>
                            <div class="row"
                                v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                                <div class="col-md-12 mt-4 mb-1" v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">
                                    <h6 class="text-info">번들x{{ a.upBundlingSize || 1 }}</h6>
                                    <h6>1. 풀필먼트수수료(배송비)</h6>
                                    <div class="custom-control-inline ml-3">
                                        {{ Math.round(a.수수료?.배송비 * 1.1) }}
                                    </div>
                                    <h6>2. 입출고수수료</h6>
                                    <div class="custom-control-inline ml-3">
                                        {{ Math.round(a.수수료?.입출고비 * 1.1) }}
                                    </div>
                                    <h6>3. 판매수수료(판매수수료율)</h6>
                                    <div class="custom-control-inline ml-3">
                                        {{ Math.round(a.수수료?.판매수수료 * 1.1) }}({{ Math.round(a.수수료?.판매수수료율 * 1.1 * 100) / 100 }}%)
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                    </template>
                    <template v-slot:매입가="{ item }">
                        <b-button v-if="item.매입가" variant="outline-success" class="mb-1 mr-2"
                            v-b-modal="'modalImport' + item._id">{{ item.매입가 || "" }}</b-button>
                        <b-button v-else variant="outline-secondary" class="mb-1 mr-2"
                            v-b-modal="'modalImport' + item._id">입력</b-button>

                        <b-modal :id="'modalImport' + item._id" size="lg" title="매입정보" ok-title="저장" cancel-title="취소"
                            @ok="saveImport($event, item)">
                            <p class="mb-1">매입가는 부가세가 포함된 전체 매입가로 입력해 주세요</p>
                            <p class="small text-muted">
                                쿠패스가 자동 계산한 줄은 <b>▸</b> 를 누르면 그 매입가가 어떻게 나왔는지(1688·물류비·창고비 내역) 펼쳐집니다.
                            </p>
                            <div class="row" v-if="showImport">
                                <div class="col-md-12">
                                    <div class="table-responsive">
                                        <table id="datatable"
                                            class="table data-table table-striped dataTable text-center"
                                            style="font-size:90%">
                                            <thead>
                                                <tr class="ligth ligth-data">
                                                    <th style="font-size:90%">Date</th>
                                                    <th style="font-size:90%">매입가</th>
                                                    <th style="font-size:90%">수량</th>
                                                    <th style="font-size:90%">구분</th>
                                                    <th style="font-size:90%">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <!-- 본문 행과 펼침 행을 함께 감싼다 —
                                                     펼침 tr 을 v-for 밖에 두면 list/idx 가 스코프 밖이라 렌더에서 터진다 -->
                                                <template v-for="(list, idx) in item.매입정보">
                                                <tr :key="idx">
                                                    <td>
                                                        <div v-if="!editmode">
                                                            {{ list.date }}
                                                        </div>
                                                        <div v-else>
                                                            <input type="date" class="form-control ml-1 text-center"
                                                                v-model="list.date"
                                                                @keyup.enter="changeImportInfo($event)">
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div v-if="!editmode">
                                                            {{ list.매입가 }}
                                                        </div>
                                                        <div v-else>
                                                            <input type="number" class="form-control ml-1 text-center"
                                                                v-model="list.매입가"
                                                                @keyup.enter="changeImportInfo($event)">
                                                        </div>
                                                    </td>
                                                    <!-- 쿠패스가 자동 계산한 lot 은 수량·입고ID 를 갖는다.
                                                         화주 수기 입력분과 섞이므로 어느 쪽인지 보여준다(정본 §5 Phase 3-15). -->
                                                    <td>{{ list.수량 != null ? Number(list.수량).toLocaleString() : '-' }}</td>
                                                    <td style="font-size:85%">
                                                        <a v-if="list.계산내역" href="javascript:void(0)"
                                                            class="mr-1" @click.stop="toggleLotDetail(item._id, idx)"
                                                            v-b-tooltip.hover title="계산 내역 펼치기">
                                                            {{ isLotOpen(item._id, idx) ? '▾' : '▸' }}
                                                        </a>
                                                        <span v-if="list.입고ID">
                                                            <b-badge variant="info">쿠패스 자동</b-badge>
                                                            <b-badge v-if="list.잠정" variant="warning" class="ml-1"
                                                                v-b-tooltip.hover title="통관 반출 시점에 미리 계산한 값입니다. 쿠팡 실입고 수량이 잡히면 보정됩니다.">잠정</b-badge>
                                                            <div class="text-muted">{{ list.입고ID }}</div>
                                                        </span>
                                                        <b-badge v-else variant="light">수기</b-badge>
                                                    </td>
                                                    <td>
                                                        <!-- <a class="badge badge-secondary mr-2" data-toggle="tooltip" v-b-tooltip.top title="Edit" href="javascript:void(0)" @click="editImport()">
                                                            <i class="ri-eye-line mr-0"></i>
                                                        </a> -->
                                                        <a class="badge bg-warning mr-2" data-toggle="tooltip"
                                                            v-b-tooltip.top title="Delete" href="javascript:void(0)"
                                                            @click="deleteImport(item, idx)">
                                                            <i class="ri-delete-bin-line mr-0"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                                <!-- 계산 내역 펼침 — 이 매입가가 어떻게 나왔는지.
                                                     저장은 하는데 안 보여주면 화주가 숫자를 믿을 근거가 없다 -->
                                                <tr v-if="list.계산내역 && isLotOpen(item._id, idx)" :key="'d-' + idx">
                                                    <td colspan="5" class="text-left" style="background:#f7f9fc;font-size:85%">
                                                        <!-- 쿠패스 자동계산 lot -->
                                                        <div v-if="list.계산내역.총비용 !== undefined" class="d-flex flex-wrap" style="gap:4px 18px">
                                                            <span>1688 구매 <b>{{ (list.계산내역.금액_1688 || 0).toLocaleString() }}</b></span>
                                                            <span>중국물류 <b>{{ (list.계산내역.금액_중국물류 || 0).toLocaleString() }}</b></span>
                                                            <span>한국물류 <b>{{ (list.계산내역.금액_한국물류 || 0).toLocaleString() }}</b></span>
                                                            <span>공통물류 <b>{{ (list.계산내역.금액_공통물류 || 0).toLocaleString() }}</b></span>
                                                            <span v-if="list.계산내역.금액_국내창고">국내창고 <b>{{ list.계산내역.금액_국내창고.toLocaleString() }}</b></span>
                                                            <span class="text-primary">
                                                                총비용 <b>{{ (list.계산내역.총비용 || 0).toLocaleString() }}</b>
                                                                ÷ 요청수량 <b>{{ (list.계산내역.구매요청수량 || 0).toLocaleString() }}</b>
                                                                = <b>{{ Number(list.매입가 || 0).toLocaleString() }}</b>
                                                            </span>
                                                            <span v-if="list.계산내역.계산일" class="text-muted">계산일 {{ list.계산내역.계산일 }}</span>
                                                        </div>
                                                        <!-- 국내창고 수동 입고 lot -->
                                                        <div v-else class="d-flex flex-wrap" style="gap:4px 18px">
                                                            <span>구분 <b>{{ list.계산내역.사유 }}</b></span>
                                                            <span>입력 매입가 <b>{{ (list.계산내역.입력매입가 || 0).toLocaleString() }}</b></span>
                                                            <span v-if="list.계산내역.추가비용">추가비용 <b>{{ list.계산내역.추가비용.toLocaleString() }}</b> ÷ {{ list.수량 }}개</span>
                                                            <span class="text-primary">= <b>{{ Number(list.매입가 || 0).toLocaleString() }}</b></span>
                                                            <span v-if="list.계산내역.계산일" class="text-muted">계산일 {{ list.계산내역.계산일 }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </template>
                                                <tr>
                                                    <div class="d-flex justify-content-start mt-2 ml-4 mb-2">
                                                        <b-button @click="addImportInfo(item)" variant="outline-primary"
                                                            class="text-center">+ 추가</b-button>
                                                        <b-button @click="editImport()" variant="outline-secondary"
                                                            class="text-center ml-2">편집</b-button>
                                                    </div>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- <div class="d-flex justify-content-between">
                                        <button type="button" class="btn btn-success mr-2 mb-4" @click="resetAutoList">전체삭제</button>
                                        <button type="button" class="btn btn-primary mr-2 mb-4" @click="collectAll">전체수집</button>
                                    </div> -->
                                </div>
                            </div>
                        </b-modal>
                    </template>
                    <template v-slot:밀크런비용="{ item }">
                        <!-- 표시값 = 마진 계산에 쓰는 값(지금 팔리는 입고 lot 의 원/개, #112). 근거값이 0/없으면 옛 값으로 덮지 않는다(#4) -->
                        <b-button v-if="milkrunShown(item).상태 === '값'" variant="outline-info" class="mb-1 mr-2"
                            v-b-modal="'modalMilkrun' + item._id">{{ milkrunShown(item).원 }}</b-button>
                        <b-button v-else-if="milkrunShown(item).상태 === '정보없음'" variant="outline-secondary" size="sm" class="mb-1 text-nowrap" style="font-size:11px;padding:2px 4px"
                            title="밀크런 입고 기록은 있지만 지금 팔리는 입고분에 맞는 밀크런 비용이 없습니다"
                            v-b-modal="'modalMilkrun' + item._id">밀크런 정보 없음</b-button>
                        <span v-else>-</span>

                        <b-modal :id="'modalMilkrun' + item._id" size="md" title="밀크런 입고 이력" ok-only ok-title="닫기">
                            <div class="table-responsive" v-if="item.밀크런정보 && item.밀크런정보.length > 0">
                                <table class="table data-table table-striped dataTable text-center" style="font-size:90%">
                                    <thead>
                                        <tr class="ligth ligth-data">
                                            <th>날짜</th>
                                            <th>밀크런번호</th>
                                            <th>비용(개당)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(info, idx) in item.밀크런정보" :key="idx">
                                            <td>{{ info.date }}</td>
                                            <td>{{ info.milkrunSeq }}</td>
                                            <td>{{ info.밀크런비용 ? info.밀크런비용.toLocaleString() + '원' : '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p v-else class="text-muted text-center">밀크런 입고 이력이 없습니다.</p>
                        </b-modal>
                    </template>
                    <template v-slot:orderableQuantity="{ item }">
                        <div>{{ item.orderableQuantity }}</div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.orderableQuantity }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.orderableQuantity }}</div>
                        </div>
                    </template>
                    <template v-slot:salePrice="{ item }">
                        <div>{{ item.salePrice }}</div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.salePrice }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.salePrice }}</div>
                        </div>
                    </template>
                    <template v-slot:coupon="{ item }">
                        <div>{{ item.coupon }}</div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.coupon }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.coupon }}</div>
                        </div>
                    </template>
                    <!-- 다운로드쿠폰은 최소구매금액·일일한도 조건이 붙고 고객이 받아야 적용된다.
                         그래서 판매가에서 빼지 않고(마진 왜곡) 조건과 함께 보여주기만 한다 -->
                    <template v-slot:downloadCouponInfo="{ item }">
                        <div v-if="item.downloadCouponInfo">
                            <div>{{ (item.downloadCouponInfo.discount || 0).toLocaleString() }}원</div>
                            <small class="text-muted" :title="item.downloadCouponInfo.description">
                                {{ 다운로드쿠폰조건(item.downloadCouponInfo) }}
                            </small>
                        </div>
                        <div v-else>-</div>
                    </template>
                    <template v-slot:마진="{ item }">
                        <div v-if="item.매입가">
                            <div :title="marginBasisTitle(item)">{{ item.마진 }}</div>
                            <small v-if="milkrunShown(item).상태 === '정보없음'" class="text-muted" title="밀크런 정보가 없어 밀크런 0원으로 계산한 마진입니다">밀크런 미반영</small>
                            <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                                <div v-for="a, i in item.returnProducts" :key="i" :title="marginBasisTitle(a)">{{ a.마진 }}</div>
                            </div>
                            <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                                <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i" :title="marginBasisTitle(a)">{{ a.마진 }}</div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:마진율="{ item }">
                        <div v-if="item.매입가">
                            <div>{{ Math.round(item.마진율 * 100) }}%</div>
                            <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                                <div v-for="a, i in item.returnProducts" :key="i">{{ Math.round(a.마진율 * 100) }}%</div>
                            </div>
                            <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                                <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ Math.round(a.마진율 * 100) }}%</div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:ROI="{ item }">
                        <div v-if="item.매입가">
                            <div>{{ Math.round(item.ROI * 100) }}%</div>
                            <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                                <div v-for="a, i in item.returnProducts" :key="i">{{ Math.round(a.ROI * 100) }}%</div>
                            </div>
                            <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                                <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ Math.round(a.ROI * 100) }}%</div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:ROAS="{ item }">
                        <div v-if="item.매입가">
                            <div>{{ Math.round(item.ROAS * 100) }}%</div>
                            <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                                <div v-for="a, i in item.returnProducts" :key="i">{{ Math.round(a.ROAS * 100) }}%</div>
                            </div>
                            <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                                <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ Math.round(a.ROAS * 100) }}%</div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:gmvForLast7Days="{ item }">
                        <div>{{ item.gmvForLast7Days }}</div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.gmvForLast7Days }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.gmvForLast7Days }}</div>
                        </div>
                    </template>
                    <template v-slot:gmvForLast30Days="{ item }">
                        <div>{{ item.gmvForLast30Days }}</div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.gmvForLast30Days }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.gmvForLast30Days }}</div>
                        </div>
                    </template>
                    <template v-slot:unitsSoldForLast7Days="{ item }">
                        <div>{{ item.unitsSoldForLast7Days }}</div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.unitsSoldForLast7Days }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.unitsSoldForLast7Days }}</div>
                        </div>
                    </template>
                    <template v-slot:unitsSoldForLast30Days="{ item }">
                        <div>{{ item.unitsSoldForLast30Days }}</div>
                        <div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
                            <div v-for="a, i in item.returnProducts" :key="i">{{ a.unitsSoldForLast30Days }}</div>
                        </div>
                        <div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
                            <div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">{{ a.unitsSoldForLast30Days }}</div>
                        </div>
                    </template>

                </CDataTable>
            </div>

            <b-modal size="xl" id="excelupload" scrollable title="매입정보 관리" hide-footer>
                <!-- 탭 네비게이션 -->
                <b-tabs v-model="activeTab" content-class="mt-3">
                    <!-- 일괄 업로드 탭 -->
                    <b-tab title="일괄 업로드" active>
                        <div class="row">
                            <div class="col-md-12">
                                <p><strong>[업로드 방법]</strong></p>
                                <p>1. 엑셀업로드 포맷 다운로드 → 2. 엑셀 파일에서 매입정보 업데이트 → 3. 업데이트된 엑셀 파일 업로드</p>
                                <p><small class="text-muted">* 동일 날짜 데이터가 있으면 자동으로 새 데이터로 교체됩니다.</small></p>
                            </div>
                        </div>

                        <!-- 옵션ID 매칭 방식 -->
                        <div class="card mb-3">
                            <div class="card-header bg-primary text-white">
                                <h6 class="mb-0"><i class="fa fa-barcode mr-2"></i>옵션ID(vendorItemId)로 매칭</h6>
                            </div>
                            <div class="card-body">
                                <div class="row align-items-end">
                                    <div class="col-md-4">
                                        <label class="form-label">엑셀 포맷 다운로드</label>
                                        <div>
                                            <button type="button" @click="formatDownload('vendorItemId')"
                                                class="btn btn-outline-primary btn-block">
                                                <i class="fa fa-download mr-1"></i>옵션ID 포맷 다운로드
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">엑셀 파일 업로드</label>
                                        <div class="custom-file">
                                            <input ref="vendorItemIdUpload" type="file" @change="uploadfile($event, 'vendorItemId')"
                                                class="custom-file-input" id="vendorItemIdFile" accept=".xlsx,.xls">
                                            <label class="custom-file-label" for="vendorItemIdFile">{{ uploadstatus }}</label>
                                        </div>
                                    </div>
                                    <div class="col-md-2" v-if="showuploadspinner && currentUploadType === 'vendorItemId'">
                                        <img style="width:30px;" :src="require('../../../assets/images/small/loading.gif')">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 바코드 매칭 방식 -->
                        <div class="card">
                            <div class="card-header bg-success text-white">
                                <h6 class="mb-0"><i class="fa fa-qrcode mr-2"></i>바코드(barcode)로 매칭</h6>
                            </div>
                            <div class="card-body">
                                <div class="row align-items-end">
                                    <div class="col-md-4">
                                        <label class="form-label">엑셀 포맷 다운로드</label>
                                        <div>
                                            <button type="button" @click="formatDownload('barcode')"
                                                class="btn btn-outline-success btn-block">
                                                <i class="fa fa-download mr-1"></i>바코드 포맷 다운로드
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">엑셀 파일 업로드</label>
                                        <div class="custom-file">
                                            <input ref="barcodeUpload" type="file" @change="uploadfile($event, 'barcode')"
                                                class="custom-file-input" id="barcodeFile" accept=".xlsx,.xls">
                                            <label class="custom-file-label" for="barcodeFile">{{ uploadstatus2 }}</label>
                                        </div>
                                    </div>
                                    <div class="col-md-2" v-if="showuploadspinner && currentUploadType === 'barcode'">
                                        <img style="width:30px;" :src="require('../../../assets/images/small/loading.gif')">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>

                    <!-- 매입정보 관리 탭 -->
                    <b-tab title="매입정보 관리">
                        <!-- 액션 버튼 바 -->
                        <div class="row mb-3">
                            <div class="col-12">
                                <button type="button" class="btn btn-success mr-2" @click="addNewImportInfo">
                                    <i class="fa fa-plus"></i> 새 항목 추가
                                </button>
                                <button type="button" class="btn btn-danger mr-2" @click="deleteSelectedImportInfo"
                                    :disabled="selectedImportInfoItems.length === 0">
                                    <i class="fa fa-trash"></i> 선택 삭제 ({{ selectedImportInfoItems.length }})
                                </button>
                                <button type="button" class="btn btn-warning mr-2" @click="deleteAllImportInfo">
                                    <i class="fa fa-trash-alt"></i> 전체 삭제
                                </button>
                                <button type="button" class="btn btn-info mr-2" @click="exportImportInfoToExcel">
                                    <i class="fa fa-download"></i> 엑셀 다운로드
                                </button>
                            </div>
                        </div>

                        <!-- 필터/검색 바 -->
                        <div class="row mb-3">
                            <div class="col-md-3">
                                <label class="form-label">시작일</label>
                                <input type="date" class="form-control" v-model="importInfoFilter.startDate">
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">종료일</label>
                                <input type="date" class="form-control" v-model="importInfoFilter.endDate">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">상품명/옵션ID 검색</label>
                                <input type="text" class="form-control" v-model="importInfoFilter.searchText"
                                    placeholder="상품명 또는 옵션ID 입력" @keyup.enter="filterImportInfos">
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-primary btn-block" @click="filterImportInfos">
                                        <i class="fa fa-search"></i> 검색
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- 매입정보 테이블 -->
                        <CDataTable
                            storage-key="growthdb.2"
                            :headers="importInfoHeaders"
                            :items="filteredImportInfos"
                            v-model="selectedImportInfoItems"
                            :show-select="true"
                            itemKey="id"
                            :per-page="importInfoPerPage"
                            style="margin-bottom: 10px">

                            <template v-slot:노출ID="{ item }">
                                <div>{{ item.productId }}</div>
                            </template>

                            <template v-slot:옵션ID="{ item }">
                                <div>{{ item.vendorItemId }}</div>
                            </template>

                            <template v-slot:상품명="{ item }">
                                <div>{{ item.productName }}</div>
                            </template>

                            <template v-slot:매입일자="{ item }">
                                <div v-if="item.editing">
                                    <input type="date" class="form-control form-control-sm"
                                        v-model="item.date"
                                        @keyup.enter="saveImportInfoEdit(item)"
                                        @blur="saveImportInfoEdit(item)">
                                </div>
                                <div v-else>{{ item.date }}</div>
                            </template>

                            <template v-slot:매입가="{ item }">
                                <div v-if="item.editing">
                                    <input type="number" class="form-control form-control-sm"
                                        v-model="item.매입가"
                                        @keyup.enter="saveImportInfoEdit(item)"
                                        @blur="saveImportInfoEdit(item)">
                                </div>
                                <div v-else>{{ item.매입가 | currency }}</div>
                            </template>

                            <template v-slot:액션="{ item }">
                                <div>
                                    <button v-if="!item.editing" type="button" class="btn btn-sm btn-outline-primary mr-1"
                                        @click="editImportInfo(item)">
                                        <i class="fa fa-edit"></i>
                                    </button>
                                    <button v-if="item.editing" type="button" class="btn btn-sm btn-success mr-1"
                                        @click="saveImportInfoEdit(item)">
                                        <i class="fa fa-check"></i>
                                    </button>
                                    <button v-if="item.editing" type="button" class="btn btn-sm btn-secondary mr-1"
                                        @click="cancelImportInfoEdit(item)">
                                        <i class="fa fa-times"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-danger"
                                        @click="deleteImportInfo(item)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </template>
                        </CDataTable>
                    </b-tab>
                </b-tabs>

                <!-- 모달 하단 버튼 -->
                <template #modal-footer>
                    <button type="button" class="btn btn-secondary" @click="closeImportInfoModal">닫기</button>
                </template>
            </b-modal>

            <b-modal :id="'addManage'" size="xl" title="숨김상품" ok-only>
                <b-button variant="outline-primary" size="sm" class="mb-1 mr-1" @click="importHideProducts">다시
                    불러오기</b-button>
                <div class="row">
                    <img v-if="showspinner2" style="max-width:100%;"
                        :src="require('../../../assets/images/small/spinner.gif')">
                </div>
                <div class="row" v-if="showHideProducts">
                    <div class="col-12 mt-3">
                        <CDataTable
                            storage-key="growthdb.3"
                            :headers="hideProductHeaders"
                            :items="searchProducts"
                            itemKey="vendorItemId"
                            style="margin-bottom: 10px">

                            <template v-slot:제품정보="{ item }">
                                <!-- GrowthDB 문서의 이름/이미지 필드는 skuName / imgUrl 이다.
                                     productName·optionImageUrl 은 존재하지 않아 이름이 빈 채로 나오고 있었다. -->
                                <div class="d-flex align-items-center py-2">
                                    <img :src="item.imgUrl" class="img-fluid rounded avatar-80 mr-3" alt="image">
                                    <div>
                                        {{ item.skuName || item.itemName || item.displayProductName }}
                                        <p class="mb-0"><small>노출Id : {{ item.productId }}</small></p>
                                        <p class="mb-0"><small>옵션Id : {{ item.vendorItemId }}</small></p>
                                        <p class="mb-0"><small>승인상태 : {{ item.statusName }}</small></p>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:숨김처리취소="{ item }">
                                <b-button @click="addSearchProduct(item)" variant="outline-primary" size="sm"
                                    class="text-center">숨김처리취소</b-button>
                            </template>
                        </CDataTable>
                    </div>
                </div>
            </b-modal>

            <!-- 허용 vendorName 설정 모달 -->
            <b-modal id="vendorNameModal" size="lg" title="허용 스토어 설정" ok-title="저장" cancel-title="취소"
                @ok="saveAllowedVendorNames" @cancel="cancelVendorNameModal">
                <div class="row">
                    <div class="col-md-12">
                        <p><b>타사매칭 여부 확인을 위한 허용 스토어를 설정해주세요.</b></p>
                        <p>설정된 스토어 외의 다른 판매자가 있는 상품은 '타사매칭' 상품으로 분류됩니다.</p>

                        <div class="form-group">
                            <label>허용 스토어 목록 (쉼표로 구분, 예: 마이브랜드, 곰곰, 탐사)</label>
                            <textarea v-model="allowedVendorNamesText" class="form-control" rows="4"
                                placeholder="예: 마이브랜드, 곰곰, 탐사"></textarea>
                        </div>

                        <div class="form-group d-flex align-items-center" v-if="currentAllowedVendorNames.length > 0">
                            <label>현재 설정된 허용 스토어</label>
                            <div class="d-flex flex-wrap ml-3">
                                <span v-for="(name, index) in currentAllowedVendorNames" :key="index"
                                    class="badge badge-primary mr-2 mb-2">{{ name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>

            <div class="mb-4 ml-1 d-none" id="printMe8">
                <div v-for="index in parseInt(출력수량)" :key="index">
                    <div class="row d-flex justify-content-center ml-1" :style="barcodegap(index, parseInt(출력수량))">
                        <div class="col-12 d-flex flex-left mb-0"
                            style="margin-top:0px;margin-bottom:0px;margin-left:10px;margin-right:10px;display:flex;justify-content: space-between;">
                            <div class="mb-0" style="font-size:90%;color:black;">{{ 원산지 }}</div>
                        </div>
                        <div class="col-12 text-center d-flex justify-content-center mt-0 mb-0"
                            style="margin-top:0px;margin-bottom:0px">
                            <barcode :value="출력바코드" :tag="bctag" height="50"
                                :options="{ lineColor: '#0275d8', text: 'Scan', margin: 0 }"></barcode>
                        </div>
                        <div v-if="printfoodenable" style="width:100%;margin-top:0px;margin-bottom:0px;margin-left:10px;font-size:80%;">
                            <span style="font-size:80%;color:black;display:block">{{ 출력상품명 }}</span>
                            <div style="font-size:90%;font-weight:bold">식품위생법에 의한 한글표시사항</div>
                        </div>
                        <div class="col-12 mt-0 mb-0"
                            style="margin-top:0px;margin-bottom:0px;margin-left:10px;margin-right:10px;text-align:left;line-height:5px;">
                            <span v-if="!printfoodenable" :style="disablekr">{{ 출력상품명 }}</span><br>
                            <span :style="enablekr">1. 상품명 : {{ 출력상품명 }}</span><br>
                            <span :style="enablekr">2. 수입원/판매원 : {{ 한글표시사항['수입원/판매원'] }}</span><br>
                            <span :style="enablekr">3. 제조원 : {{ 한글표시사항.제조원 }}</span><br>
                            <span :style="enablekr">4. 제조국 : {{ 한글표시사항.제조국 }}</span><br>
                            <span :style="enablekr">5. 내용량 : {{ 한글표시사항.내용량 }}</span><br>
                            <span :style="enablekr">6. 원료명및성분명(재질) : {{ 한글표시사항['원료명및성분명(재질)'] }}</span><br>
                            <div style="display: flex;justify-content: space-between;">
                                <div>
                                    <span :style="enablekr">7. 상품유형 : {{ 한글표시사항.상품유형 }}</span><br>
                                    <span :style="enablekr">8. 사용시주의사항 : {{ 한글표시사항.사용시주의사항 }}</span><br>
                                    <span :style="enablekr">9. 사용기준 : {{ 한글표시사항.사용기준 }}</span><br>
                                    <span v-if="한글표시사항.custom" :style="enablekr">10. {{ 한글표시사항.custom }}</span><br v-if="한글표시사항.custom">
                                </div>
                                <div style="height:60px;margin-right:10px;margin-top:10px;margin-left:10px;">
                                    <img v-if="printfoodenable" style="height:100%" :src="require('../../../assets/images/small/ForFood.png')">
                                    <img v-if="printkcenable" style="height:100%" :src="require('../../../assets/images/small/KcMark.jpg')">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        <!-- Page end  -->

        <!-- 노출ID 변경 이력 모달 -->
        <b-modal id="productIdHistoryModal" title="노출ID 변경 이력" hide-footer size="lg">
            <div v-if="selectedProductForHistory">
                <p class="mb-3">
                    <strong>상품명:</strong> {{ selectedProductForHistory.상품명 || selectedProductForHistory.skuName || '-' }}<br>
                    <strong>현재 노출ID:</strong> {{ selectedProductForHistory.productId }}
                </p>
                <table class="table table-bordered table-sm" v-if="getProductIdHistoryRows(selectedProductForHistory).length > 0">
                    <thead class="thead-light">
                        <tr>
                            <th style="width: 35%;">변경일</th>
                            <th style="width: 32.5%;">변경 전 노출ID</th>
                            <th style="width: 32.5%;">변경 후 노출ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, idx) in getProductIdHistoryRows(selectedProductForHistory)" :key="idx">
                            <td>{{ new Date(row.date).toLocaleString('ko-KR') }}</td>
                            <td>{{ row.fromProductId }}</td>
                            <td>{{ row.toProductId }}</td>
                        </tr>
                    </tbody>
                </table>
                <p v-else class="text-muted">노출ID 변경 이력이 없습니다.</p>
            </div>
        </b-modal>

    </div>
</template>
<script>
import axios from 'axios';
import * as XLSX from 'xlsx';
import VueBarcode from 'vue-barcode';
import CDataTable from "@/components/common/CDataTable";
import * as adDomain from "@/utils/adDomain";
import keepAliveViewMixin from '@/mixins/keepAliveViewMixin';
import { 대표매입가, 밀크런표시 } from '@/utils/lotCost';
export default {
    // keep-alive :include는 컴포넌트 name으로 매칭한다.
    // 'Listproduct'는 다른 화면 3개가 같이 쓰고 있어서 고유 이름으로 바꿨다.
    name: 'GrowthDb',
    mixins: [keepAliveViewMixin],
    data() {
        return {
            selectedProductForHistory: null,
            headers: [
                { text: '상품등급', value: '상품등급', align: 'center', width: 100, isSlot: true },
                { text: '이미지', value: '이미지', align: 'center', width: 100, isSlot: true },
                { text: '상품명', value: '상품명', align: 'center', width: 300, isSlot: true },
                { text: '노출ID', value: 'productId', align: 'center', width: 100, isSlot: true },
                { text: '옵션ID', value: 'vendorItemId', align: 'center', width: 100, isSlot: true },
                // {text: '등록상품ID', value: 'vendorInventoryId', align: 'center', width: 100, isSlot: false},
                { text: '바코드', value: 'barcode', align: 'center', width: 100, isSlot: true },

                { text: '판매링크', value: 'link', align: 'center', width: 100, isSlot: true },
                { text: '구매관리', value: '구매정보', align: 'center', width: 100, isSlot: true },
                { text: '매입관리', value: '매입가', align: 'center', width: 100, isSlot: true },
                { text: '밀크런비용', value: '밀크런비용', align: 'center', width: 100, isSlot: true },

                { text: '아이템위너', value: 'winner', align: 'center', width: 100, isSlot: true },
                { text: '뱃지', value: 'badge', align: 'center', width: 100, isSlot: true },
                { text: '사이즈', value: '수수료.sizeName', align: 'center', width: 100, isSlot: true },
                { text: '쿠팡재고', value: 'orderableQuantity', align: 'center', width: 100, isSlot: true },


                { text: '판매가', value: 'salePrice', align: 'center', width: 100, isSlot: true },
                { text: '할인쿠폰', value: 'coupon', align: 'center', width: 100, isSlot: true },
                { text: '다운로드쿠폰', value: 'downloadCouponInfo', align: 'center', width: 130, isSlot: true },
                { text: '수수료', value: 'commission', align: 'center', width: 100, isSlot: true },

                { text: '마진', value: '마진', align: 'center', width: 100, isSlot: true },
                { text: '마진율', value: '마진율', align: 'center', width: 100, isSlot: true },
                { text: 'ROI', value: 'ROI', align: 'center', width: 100, isSlot: true },
                { text: '최소ROAS', value: 'ROAS', align: 'center', width: 100, isSlot: true },

                { text: '7일매출', value: 'gmvForLast7Days', align: 'center', width: 100, isSlot: true },
                { text: '30일매출', value: 'gmvForLast30Days', align: 'center', width: 100, isSlot: true },
                { text: '7일판매량', value: 'unitsSoldForLast7Days', align: 'center', width: 100, isSlot: true },
                { text: '30일판매량', value: 'unitsSoldForLast30Days', align: 'center', width: 100, isSlot: true },
                // {text: 'Actions', value: '', align: 'center', width: 100, isSlot: true},
            ],
            tableSelectedItem: [],
            showReturnProducts: false,
            // 쿠팡 wing 재고현황에서 '숨김' 으로 분류된 상품(coupangHidden)을 목록에 넣을지.
            // 기본 꺼짐 — 켜야만 보인다. 재고가 0이 되면 wing 숨김으로 넘어가는 경우가 많아
            // 품절·판매중지 상품이 통째로 목록에서 사라져 되돌릴 방법이 없다는 문의에서 나왔다
            // (실측 2026-09-11: 전사 3,098건이 전부 재고 0. hanbom 274건 중 150건이 이걸로 가려짐).
            showCoupangHidden: false,
            showBundleProducts: false,

            showspinner2: false,
            showHideProducts: false,
            showPurchase: true,

            packageMethod: 'auto',
            searchProducts: [],
            addProducts: [],
            노출상품번호: '',
            등록상품번호: '',
            옵션번호: '',
            purchaseItem: {},
            isCollapseOpen: false,
            allchecked: false,

            PurchaseMappingSearch: false,
            searchPurchaseMapping: '',
            loadingtext: '',

            title: "로켓그로스 상품관리",
            desc1: "로켓그로스 상품DB를 수집을 클릭하면 신규 로켓그로스 상품DB가 수집됩니다.",
            desc2: "상품의 구매정보 및 매입가 정보를 입력하여 대량구매 및 매입이력 관리가 가능합니다. ",

            showlist: false,
            showspinner: false,
            showspinner1: false,
            barcode: '',
            SKUID: '',
            상품명: '',
            구매링크: '',
            제품분류: '',
            ProductList: {
                등록이미지: '',
                구매링크: '',
                옵션1_중국어: '',
                옵션2_중국어: '',
                판매구성수량: '',
                구매가능상태: '',
            },
            editQty: false,
            printskuenable: true,
            printkcenable: false,
            printfoodenable: false,
            원산지: 'Made in China',

            // link:{ name: 'product.addproduct'},
            // linktext:"Add Product",
            //    selected: '',
            //    menuint: ["옵션1_중국어","옵션2_중국어","제품분류","판매구성수량","구매가능상태"],
            //    menuDefault: ["옵션1_중국어","옵션2_중국어","제품분류","판매구성수량","구매가능상태"],
            //    menuCost: ["발주가능상태","매입단가","공급가액","부가세액"],
            //    // menuSales: ["바코드","구매링크","판매가격","판매링크","판매재고","판매상품명"],
            productLists: [], //this.$store.state.productdb,
            productListsinit: [],
            noPurchasePriceNotice: '',   // 판매장부에서 매입가 입력하러 넘어왔을 때 표시

            바코드출력: '',
            SKU출력: '',
            출력수량: 1,
            바코드간격: 0,

            enabledetail: true,

            출력SKUID: '',
            출력바코드: '',
            출력상품명: '',
            한글표시사항: {
                '수입원/판매원': '',
                제조원: '',
                제조국: '',
                내용량: '',
                '원료명및성분명(재질)': '',
                상품유형: '',
                사용시주의사항: '',
                사용기준: '',
                custom: '',
                kc인증: false,
                식품용: false,
            },
            bcvalue: '',
            bctag: 'svg',
            bcoptions: {
                lineColor: '#ff7069',
                fontSize: 50,
                font: 'Courier',
                width: 3,
                height: 60,
                marginBottom: 60,
                format: 'MSI',
                background: '#ccffff'
            },
            total: 0,
            아이템루저: 0,
            판매중지: 0,
            품절: 0,
            뱃지없음: 0,
            구매정보있음: 0,
            구매정보없음: 0,
            번들정보있음: 0,
            매입정보없음: 0,
            // 매입정보창에서 펼쳐놓은 lot. '상품_id:행번호' 를 키로 쓴다
            openLotDetails: {},
            노출ID변경: 0,
            타사매칭: 0,
            editmode: false,
            showImport: true,
            currentIndex: '',

            showuploadspinner: false,
            uploadstatus: 'excel file upload',
            uploadstatus2: 'excel file upload',
            currentUploadType: '', // 'vendorItemId' 또는 'barcode'

            // 매입정보 관리 관련
            activeTab: 0,
            importInfoFilter: {
                startDate: '',
                endDate: '',
                searchText: ''
            },
            selectedImportInfos: [],
            selectedImportInfoItems: [], // CDataTable용 선택된 아이템들
            selectAllImportInfos: false,
            currentImportInfoPage: 1,
            importInfoPerPage: 20,
            flatImportInfos: [], // 플랫 구조로 변환된 매입정보
            filteredImportInfos: [], // 필터링된 매입정보
            originalImportInfos: {}, // 편집 취소용 원본 데이터
            importInfoHeaders: [
                { text: '노출ID', value: '노출ID', align: 'center', width: 100, isSlot: true },
                { text: '옵션ID', value: '옵션ID', align: 'center', width: 120, isSlot: true },
                { text: '상품명', value: '상품명', align: 'center', width: 200, isSlot: true },
                { text: '매입일자', value: '매입일자', align: 'center', width: 120, isSlot: true },
                { text: '매입가', value: '매입가', align: 'center', width: 100, isSlot: true },
                { text: '액션', value: '액션', align: 'center', width: 150, isSlot: true }
            ],

            // 숨김상품(숨김처리취소) 모달용
            hideProductHeaders: [
                { text: '제품정보', value: '제품정보', align: 'left', width: 420, isSlot: true },
                { text: '숨김처리취소', value: '숨김처리취소', align: 'center', width: 140, isSlot: true }
            ],

            // 허용 vendorName 관련
            allowedVendorNamesText: '',
            currentAllowedVendorNames: []
        }
    },
    components: {
        'barcode': VueBarcode,
        CDataTable
    },
    activated() {
        // 탭으로 다시 열렸을 때도 판매장부에서 넘어온 필터를 적용한다
        this.$nextTick(() => this.applyLedgerHandoff());
    },
    mounted() {
        this.messageEventHandler = async (event) => {
            if (event.data.msg && event.data.msg === 'growthDb') {
                if (event.data.res == 'success') {
                    this.showlist = false;
                    this.loadingtext = '수집 상품 저장 중 ...';
                    console.log(event.data)

                    // 기존 store 데이터와 비교하여 productId 변경 감지 및 이력 추가
                    const growthdb = event.data.growthdb.map(item => {
                        const newItem = {
                            ...item,
                            companyid: this.$store.state.user.companyid,
                            suppliercode: this.$store.state.user.suppliercode
                        };

                        // 기존 데이터에서 같은 vendorItemId 찾기
                        const existingItem = this.$store.state.growthdb.find(e => e.vendorItemId === item.vendorItemId);

                        if (existingItem) {
                            // productId 변경 감지
                            if (existingItem.productId !== item.productId) {
                                // 기존 productIdHistory가 있으면 유지, 없으면 빈 배열
                                const currentHistory = existingItem.productIdHistory || [];

                                // 새로운 이력 추가 (기존 productId를 이력에 저장)
                                currentHistory.push({
                                    date: new Date(),
                                    productId: existingItem.productId
                                });

                                // 새 데이터에 업데이트된 이력 포함
                                newItem.productIdHistory = currentHistory;
                            } else if (existingItem.productIdHistory) {
                                // productId가 변경되지 않았지만 기존 이력이 있으면 유지
                                newItem.productIdHistory = existingItem.productIdHistory;
                            }
                        }

                        return newItem;
                    });
                    var vendorItemIds = growthdb.map(e => e.vendorItemId);

                    // 청크 단위로 데이터 처리
                    const CHUNK_SIZE = 50; // 한 번에 처리할 데이터 크기
                    const chunks = [];
                    for (let i = 0; i < growthdb.length; i += CHUNK_SIZE) {
                        chunks.push(growthdb.slice(i, i + CHUNK_SIZE));
                    }

                    let totalProcessed = 0;
                    let successCount = 0;
                    let failCount = 0;
                    let totalCntUpdate = 0;
                    let totalCntReg = 0;

                    try {
                        for (let i = 0; i < chunks.length; i++) {
                            const chunk = chunks[i];
                            this.loadingtext = `수집 상품 저장 중 ... (${Math.round((totalProcessed / growthdb.length) * 100)}%)`;

                            try {
                                // 삭제 동기화(vendorItemIds)는 마지막 청크에서, 앞 청크가 전부 성공했을 때만 보낸다.
                                // 매 청크마다 보내면 첫 청크에서 이미 지워지므로, 뒤 청크가 실패했을 때
                                // 그만큼의 상품이 삭제된 채 복구되지 않는다(구매정보는 PurchaseDB 에 남지만
                                // 숨김상태·밀크런비용 등 GrowthDB 안의 값은 복구 불가).
                                const isLastChunk = i === chunks.length - 1;
                                const result = await axios.post('/api/updateGrowthDBV2', {
                                    growthdb: chunk,
                                    vendorItemIds: (isLastChunk && failCount === 0) ? vendorItemIds : []
                                });

                                if (result.data.res === 'success') {
                                    successCount++;
                                    totalCntUpdate += result.data.cnt_update;
                                    totalCntReg += result.data.cnt_reg;
                                } else {
                                    console.log(chunk)
                                    failCount++;
                                    console.error('청크 처리 실패:', result.data.alert);
                                }
                            } catch (err) {
                                failCount++;
                                console.error('청크 처리 중 오류:', err);
                            }

                            totalProcessed += chunk.length;

                            // 진행 상황 업데이트
                            this.loadingtext = `수집 상품 저장 중 ... (${Math.round((totalProcessed / growthdb.length) * 100)}%)
                                성공: ${successCount}/${chunks.length} 청크,
                                업데이트: ${totalCntUpdate}, 신규: ${totalCntReg}`;

                            // 청크 사이에 짧은 딜레이
                            await new Promise(resolve => setTimeout(resolve, 50));
                        }

                        // 모든 청크 처리 완료 후
                        if (failCount === 0) {
                            alert(`처리 완료! 업데이트: ${totalCntUpdate}, 신규: ${totalCntReg}`);
                            this.search();
                        } else {
                            alert(`일부 처리 실패 (${failCount}/${chunks.length} 실패)\n업데이트: ${totalCntUpdate}, 신규: ${totalCntReg}`);
                        }

                    } catch (error) {
                        alert('데이터 처리 중 오류가 발생했습니다');
                        console.error('처리 중 오류:', error);
                    } finally {
                        this.$store.commit('growthdbupdate', []);
                        this.search();
                    }
                } else {
                    alert(event.data.res);
                    this.showlist = true;
                    this.showspinner = false;
                    this.showspinner1 = false;
                }
            }
            // 진행 신호가 오는 동안은 수집이 살아있다는 뜻 — 타임아웃 타이머를 다시 건다.
            // (안 걸면 15분 넘는 수집에서 진행 표시가 중간에 멈춘다)
            if (event.data.res === 'growthdbratio' || event.data.type === 'autoCollectStatus') {
                this.touchOwnCollect();
            }
            if (this.ownCollectRunning && event.data.res && event.data.res === 'growthdbratio') {
                if (event.data.ratio == 0) {
                    this.loadingtext = event.data.text
                } else {
                    this.loadingtext = event.data.text + event.data.ratio.toFixed(0) + '%'
                }
            }
            // [수집로직 일원화] 수집 완료 시 데이터 재조회
            if (event.data.type === 'manualCollectComplete' && event.data.itemKey === 'rocketGrowthProducts') {
                this.endOwnCollection();
                this.$store.commit('growthdbupdate', []);
                this.search();
            }
            // [수집로직 일원화] 진행 상태 표시
            // 진행 메시지는 itemKey 가 없다 — 내가 건 수집일 때만 반영한다
            if (this.ownCollectRunning && event.data.type === 'autoCollectStatus') {
                this.loadingtext = event.data.message;
            }
        }
        // 리스너 부착/해제는 keepAliveViewMixin이 담당한다 (보이는 동안에만 듣기)
        this.bindExtensionMessages();

        // 허용 vendorName 설정 로드
        this.loadAllowedVendorNames();

        this.$nextTick(function () {
            this.search()
        })
    },
    computed: {

        enablekr() {
            if (this.enabledetail) {
                return 'font-size:80%;color:black;line-height:110%;display:block;margin-bottom:0px;'
            } else {
                return 'font-size:80%;color:black;line-height:110%;display:none'
            }
        },
        disablekr() {
            if (this.enabledetail) {
                return 'font-size:80%;color:black;line-height:110%;display:none'
            } else {
                return 'font-size:80%;color:black;line-height:110%;display:block'
            }
        },
        printsku() {
            if (this.printskuenable) {
                return 'font-size:90%;color:black;'
            } else {
                return 'display:none;font-size:90%;color:black;'
            }
        },
        printkc() {
            if (this.printkcenable) {
                return 'font-size:90%;color:black;margin-left:20px;margin-top:10px'
            } else {
                return 'display:none;font-size:90%;color:black;'
            }
        },
        productIdChangedTooltip() {
            if (!this.productLists || this.productLists.length === 0) {
                return '7일 이내 노출ID가 변경된 상품이 없습니다.';
            }

            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

            const changedProducts = this.productLists.filter(e => {
                if (!e.productIdHistory || e.productIdHistory.length === 0) return false;
                return e.productIdHistory.some(history =>
                    new Date(history.date) >= sevenDaysAgo
                );
            });

            if (changedProducts.length === 0) {
                return '7일 이내 노출ID가 변경된 상품이 없습니다.';
            }

            let tooltip = '<div style="text-align: left; max-width: 350px;"><strong>노출ID 변경 상품:</strong><br>';

            changedProducts.slice(0, 5).forEach(product => {
                const recentChanges = product.productIdHistory
                    .filter(history => new Date(history.date) >= sevenDaysAgo)
                    .sort((a, b) => new Date(b.date) - new Date(a.date));

                if (recentChanges.length > 0) {
                    const latestChange = recentChanges[0];
                    const changeDate = new Date(latestChange.date).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' });
                    tooltip += `<div style="margin: 3px 0; font-size: 12px;">`;
                    tooltip += `• ${product.skuName || '상품명 없음'}<br>`;
                    tooltip += `<span style="color: #6c757d; margin-left: 8px;">${latestChange.productId} → ${product.productId} (${changeDate})</span>`;
                    tooltip += `</div>`;
                }
            });

            if (changedProducts.length > 5) {
                tooltip += `<div style="margin-top: 5px; font-size: 11px; color: #6c757d;">외 ${changedProducts.length - 5}개...</div>`;
            }

            tooltip += '</div>';
            return tooltip;
        },
        // 매입정보 관리 관련 computed 속성들 (CDataTable이 페이지네이션을 자체 처리하므로 간소화)
        totalImportInfoRows() {
            return this.filteredImportInfos.length;
        },
        otherSellersTooltip() {
            if (!this.productLists || this.productLists.length === 0) {
                return '타사매칭 상품이 없습니다.';
            }

            const matchingProducts = this.productLists.filter(e => {
                return e.otherSellers && e.otherSellers.hasOtherSellers;
            });

            if (matchingProducts.length === 0) {
                return '허용되지 않은 타사가 매칭된 상품이 없습니다.';
            }

            let tooltip = '<div style="text-align: left; max-width: 350px;"><strong>타사매칭 상품:</strong><br>';

            matchingProducts.slice(0, 5).forEach(product => {
                if (product.otherSellers && product.otherSellers.otherVendorNames && product.otherSellers.otherVendorNames.length > 0) {
                    tooltip += `<div style="margin: 3px 0; font-size: 12px;">`;
                    tooltip += `• ${product.skuName || '상품명 없음'}<br>`;
                    tooltip += `<span style="color: #dc3545; margin-left: 8px;">${product.otherSellers.otherVendorNames.join(', ')}</span>`;
                    tooltip += `</div>`;
                }
            });

            if (matchingProducts.length > 5) {
                tooltip += `<div style="margin-top: 5px; font-size: 11px; color: #6c757d;">외 ${matchingProducts.length - 5}개...</div>`;
            }

            tooltip += '</div>';
            return tooltip;
        }
    },
    filters: {
        currency(value) {
            if (!value) return '0';
            return new Intl.NumberFormat('ko-KR').format(value);
        }
    },
    watch: {
        // "반품상품보기" 는 이제 목록 행 수까지 바꾼다(최상위 반품등급 행 노출 여부).
        // 토글만 바꿨을 때 화면이 안 따라오면 카운트와 어긋나므로 전체 뷰로 되돌린다.
        showReturnProducts() {
            if (!this.showlist) return;
            this.productLists = this.visibleInit();
            this.total = this.productLists.length;
        },
        // "쿠팡숨김 상품보기" 는 catalogOnly() 단계(목록에 들어올 행 자체)를 바꾸므로
        // visibleInit() 만 다시 돌리면 안 되고 스토어에서 목록을 다시 만들어야 한다.
        // searchResult() 가 productListsinit·productLists·뱃지 카운트를 한꺼번에 다시 세운다.
        showCoupangHidden() {
            if (!this.showlist) return;
            this.searchResult(this.catalogOnly(this.$store.state.growthdb));
        }
    },
    methods: {
        // 다운로드쿠폰 조건을 한 줄로. 최소구매금액이 있으면 그게 제일 중요하다
        // (판매가보다 최소금액이 크면 한 개만 사서는 할인이 안 붙는다)
        다운로드쿠폰조건(info) {
            if (!info) return '';
            const parts = [];
            if (info.minPrice > 0) parts.push(Math.floor(info.minPrice / 10000) > 0
                ? (info.minPrice / 10000).toLocaleString() + '만원↑'
                : info.minPrice.toLocaleString() + '원↑');
            if (info.maxPerDaily > 0) parts.push('일' + info.maxPerDaily + '회');
            return parts.length ? '(' + parts.join(' · ') + ')' : '(조건없음)';
        },

        // 노출ID 변경 이력 모달 관련 메서드
        openProductIdHistoryModal(item) {
            this.selectedProductForHistory = item;
            this.$bvModal.show('productIdHistoryModal');
        },
        getProductIdHistoryRows(item) {
            if (!item || !item.productIdHistory || item.productIdHistory.length === 0) {
                return [];
            }
            // 시간순 정렬 (오래된 것부터)
            const sorted = [...item.productIdHistory].sort((a, b) => new Date(a.date) - new Date(b.date));
            const rows = [];
            for (let i = 0; i < sorted.length; i++) {
                const fromId = sorted[i].productId;
                const toId = (i < sorted.length - 1) ? sorted[i + 1].productId : item.productId;
                rows.push({
                    date: sorted[i].date,
                    fromProductId: fromId,
                    toProductId: toId
                });
            }
            return rows;
        },
        // 매입정보 lot 의 계산 내역 펼치기
        lotKey(productId, idx) {
            return String(productId) + ':' + idx;
        },
        isLotOpen(productId, idx) {
            return !!this.openLotDetails[this.lotKey(productId, idx)];
        },
        toggleLotDetail(productId, idx) {
            const k = this.lotKey(productId, idx);
            this.$set(this.openLotDetails, k, !this.openLotDetails[k]);
        },
        // 매입정보 관리 관련 메서드들
        initImportInfoManagement() {
            this.loadFlatImportInfos();
            this.filterImportInfos();
        },

        loadFlatImportInfos() {
            this.flatImportInfos = [];

            if (!this.$store.state.growthdb) return;

            this.$store.state.growthdb.forEach(product => {
                if (product.매입정보 && product.매입정보.length > 0) {
                    product.매입정보.forEach((importInfo, index) => {
                        this.flatImportInfos.push({
                            id: `${product.vendorItemId}_${index}`,
                            productId: product.productId,
                            vendorItemId: product.vendorItemId,
                            productName: product.상품명 || product.productName || '',
                            date: importInfo.date,
                            매입가: importInfo.매입가,
                            originalIndex: index,
                            editing: false,
                            originalData: { ...importInfo }
                        });
                    });
                }
            });
        },

        filterImportInfos() {
            let filtered = [...this.flatImportInfos];

            // 날짜 필터링
            if (this.importInfoFilter.startDate) {
                filtered = filtered.filter(info => info.date >= this.importInfoFilter.startDate);
            }
            if (this.importInfoFilter.endDate) {
                filtered = filtered.filter(info => info.date <= this.importInfoFilter.endDate);
            }

            // 텍스트 검색
            if (this.importInfoFilter.searchText) {
                const searchText = this.importInfoFilter.searchText.toLowerCase();
                filtered = filtered.filter(info =>
                    info.productName.toLowerCase().includes(searchText) ||
                    info.vendorItemId.toString().includes(searchText) ||
                    info.productId.toString().includes(searchText)
                );
            }

            this.filteredImportInfos = filtered;
        },



        editImportInfo(info) {
            this.originalImportInfos[info.id] = { ...info };
            info.editing = true;
        },

        cancelImportInfoEdit(info) {
            const original = this.originalImportInfos[info.id];
            if (original) {
                info.date = original.date;
                info.매입가 = original.매입가;
                info.editing = false;
                delete this.originalImportInfos[info.id];
            }
        },

        async saveImportInfoEdit(info) {
            try {
                // 원본 상품 데이터 찾기
                const product = this.$store.state.growthdb.find(p => p.vendorItemId === info.vendorItemId);
                if (!product || !product.매입정보) {
                    alert('상품 데이터를 찾을 수 없습니다.');
                    return;
                }

                // 매입정보 업데이트
                product.매입정보[info.originalIndex] = {
                    date: info.date,
                    매입가: parseFloat(info.매입가)
                };

                // 서버에 저장
                const success = await this.saveImportInfo(product, false);
                if (success) {
                    info.editing = false;
                    delete this.originalImportInfos[info.id];

                    // 마진 재계산
                    this.changeCost(product);
                    this.changeMargin(product);

                    alert('저장되었습니다.');
                } else {
                    // 실패시 원본 데이터로 복원
                    this.cancelImportInfoEdit(info);
                }
            } catch (error) {
                console.error('매입정보 저장 오류:', error);
                alert('저장 중 오류가 발생했습니다.');
                this.cancelImportInfoEdit(info);
            }
        },

        // 허용 vendorName 관련 메서드들
        loadAllowedVendorNames() {
            if (this.$store.state.settings && this.$store.state.settings[0] && this.$store.state.settings[0].allowedVendorNames) {
                this.currentAllowedVendorNames = this.$store.state.settings[0].allowedVendorNames;
                this.allowedVendorNamesText = this.currentAllowedVendorNames.join(', ');
            }
        },

        showVendorNameModal() {
            this.loadAllowedVendorNames();
            this.$bvModal.show('vendorNameModal');
        },

        async saveAllowedVendorNames(event) {
            event.preventDefault();

            // 텍스트를 배열로 변환 (쉼표로 구분, 공백 제거)
            const vendorNames = this.allowedVendorNamesText
                .split(',')
                .map(name => name.trim())
                .filter(name => name.length > 0);

            try {
                // HeaderStyle 방식 참고하여 settings에 저장
                const result = await axios.post('/api/saveAllowedVendorNames', {
                    allowedVendorNames: vendorNames
                });

                if (result.data.요청결과 === '저장완료') {
                    // store에 업데이트
                    this.$store.commit('settingsupdateparameter', {
                        key: 'allowedVendorNames',
                        value: vendorNames
                    });

                    this.currentAllowedVendorNames = vendorNames;
                    alert('허용 vendorName이 저장되었습니다.');
                    this.$bvModal.hide('vendorNameModal');
                } else {
                    alert('저장 실패: ' + result.data.요청결과);
                }
            } catch (error) {
                alert('저장 중 오류가 발생했습니다.');
                console.error(error);
            }
        },

        async deleteImportInfo(info) {
            if (!confirm('이 매입정보를 삭제하시겠습니까?')) return;

            try {
                const product = this.$store.state.growthdb.find(p => p.vendorItemId === info.vendorItemId);
                if (!product || !product.매입정보) {
                    alert('상품 데이터를 찾을 수 없습니다.');
                    return;
                }

                // 매입정보에서 해당 항목 삭제
                product.매입정보.splice(info.originalIndex, 1);

                // 서버에 저장
                const success = await this.saveImportInfo(product, false);
                if (success) {
                    // 마진 재계산
                    this.changeCost(product);
                    this.changeMargin(product);

                    // 플랫 데이터 다시 로드
                    this.loadFlatImportInfos();
                    this.filterImportInfos();

                    alert('삭제되었습니다.');
                } else {
                    alert('삭제 실패');
                }
            } catch (error) {
                console.error('매입정보 삭제 오류:', error);
                alert('삭제 중 오류가 발생했습니다.');
            }
        },

        async deleteSelectedImportInfo() {
            if (this.selectedImportInfoItems.length === 0) {
                alert('삭제할 항목을 선택해주세요.');
                return;
            }

            if (!confirm(`선택한 ${this.selectedImportInfoItems.length}개 항목을 삭제하시겠습니까?`)) return;

            try {
                let successCount = 0;

                for (const selectedItem of this.selectedImportInfoItems) {
                    const product = this.$store.state.growthdb.find(p => p.vendorItemId === selectedItem.vendorItemId);
                    if (!product || !product.매입정보) continue;

                    // 매입정보에서 해당 항목 삭제 (originalIndex 사용)
                    const indexToDelete = product.매입정보.findIndex(info =>
                        info.date === selectedItem.date && info.매입가 === selectedItem.매입가
                    );

                    if (indexToDelete >= 0) {
                        product.매입정보.splice(indexToDelete, 1);

                        // 서버에 저장
                        const success = await this.saveImportInfo(product, false);
                        if (success) {
                            successCount++;
                            // 마진 재계산
                            this.changeCost(product);
                            this.changeMargin(product);
                        }
                    }
                }

                // 플랫 데이터 다시 로드
                this.loadFlatImportInfos();
                this.filterImportInfos();
                this.selectedImportInfoItems = [];

                alert(`${successCount}개 항목이 삭제되었습니다.`);
            } catch (error) {
                console.error('일괄 삭제 오류:', error);
                alert('삭제 중 오류가 발생했습니다.');
            }
        },

        async deleteAllImportInfo() {
            if (!confirm('모든 매입정보를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.')) return;

            try {
                let successCount = 0;

                for (const product of this.$store.state.growthdb) {
                    if (product.매입정보 && product.매입정보.length > 0) {
                        product.매입정보 = [];

                        const success = await this.saveImportInfo(product, false);
                        if (success) {
                            successCount++;
                            // 마진 재계산
                            this.changeCost(product);
                            this.changeMargin(product);
                        }
                    }
                }

                // 플랫 데이터 다시 로드
                this.loadFlatImportInfos();
                this.filterImportInfos();
                this.selectedImportInfoItems = [];

                alert(`${successCount}개 상품의 매입정보가 삭제되었습니다.`);
            } catch (error) {
                console.error('전체 삭제 오류:', error);
                alert('삭제 중 오류가 발생했습니다.');
            }
        },

        addNewImportInfo() {
            // 새 항목 추가 모달을 띄우거나 인라인으로 추가
            // 일단 간단하게 프롬프트로 구현
            const vendorItemId = prompt('옵션ID를 입력하세요:');
            if (!vendorItemId) return;

            const date = prompt('매입일자를 입력하세요 (YYYY-MM-DD):');
            if (!date) return;

            const price = prompt('매입가를 입력하세요:');
            if (!price || isNaN(price)) return;

            this.addImportInfoToProduct(vendorItemId, date, parseFloat(price));
        },

        async addImportInfoToProduct(vendorItemId, date, price) {
            try {
                const product = this.$store.state.growthdb.find(p => p.vendorItemId === vendorItemId);
                if (!product) {
                    alert('해당 옵션ID의 상품을 찾을 수 없습니다.');
                    return;
                }

                if (!product.매입정보) {
                    product.매입정보 = [];
                }

                // 동일 날짜가 있으면 덮어쓰기
                const existingIndex = product.매입정보.findIndex(info => info.date === date);
                if (existingIndex >= 0) {
                    product.매입정보[existingIndex].매입가 = price;
                } else {
                    product.매입정보.push({ date, 매입가: price });
                }

                // 날짜순 정렬
                product.매입정보.sort((a, b) => new Date(a.date) - new Date(b.date));

                const success = await this.saveImportInfo(product, false);
                if (success) {
                    // 마진 재계산
                    this.changeCost(product);
                    this.changeMargin(product);

                    // 플랫 데이터 다시 로드
                    this.loadFlatImportInfos();
                    this.filterImportInfos();

                    alert('매입정보가 추가되었습니다.');
                } else {
                    alert('저장 실패');
                }
            } catch (error) {
                console.error('매입정보 추가 오류:', error);
                alert('추가 중 오류가 발생했습니다.');
            }
        },

        exportImportInfoToExcel() {
            if (this.filteredImportInfos.length === 0) {
                alert('내보낼 데이터가 없습니다.');
                return;
            }

            const data = this.filteredImportInfos.map(info => ({
                '노출ID': info.productId,
                '옵션ID': info.vendorItemId,
                '상품명': info.productName,
                '매입일자': info.date,
                '매입가': info.매입가
            }));

            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '매입정보');
            XLSX.writeFile(wb, `매입정보_${new Date().toISOString().split('T')[0]}.xlsx`);
        },

        openImportInfoModal() {
            this.initImportInfoManagement();
            this.$bvModal.show('excelupload');
        },

        closeImportInfoModal() {
            this.$bvModal.hide('excelupload');
        },

        cancelVendorNameModal() {
            this.loadAllowedVendorNames(); // 원래 값으로 복원
        },

        validateQuantity(list) {
            const minQuantity = this.getMinOrderQuantity(list);
            const maxQuantity = this.getAvailableStock(list);
            const currentQuantity = parseInt(list.구매요청수량);

            if (currentQuantity < minQuantity) {
                alert(`최소 주문수량(${minQuantity}개)보다 적습니다.`);
                // list.구매요청수량 = minQuantity;
            } else if (currentQuantity > maxQuantity) {
                alert(`구매 가능한 최대 수량(${maxQuantity}개)을 초과하였습니다.`);
                // list.구매요청수량 = maxQuantity;
            }
        },
        getAvailableStock(list) {
            // console.log(list)
            if (!list.item || !list.item.productSaleInfo) return 0;

            let stock = 0;
            if (!list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSaleInfo.amountOnSale);
            } else if (list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어
                )?.amountOnSale || 0);
            } else {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어 &&
                    f.skuAttributes[1].value == list.옵션2_중국어
                )?.amountOnSale || 0);
            }
            return stock;
        },
        getMinOrderQuantity(list) {
            if (!list.item) return 2;
            return list.item?.minOrderQuantity || 2;
        },
        editQtyEnter($event) {
            if ($event.keyCode == 13) {
                this.editQty = false;
            }
        },
        cancelPurchaseInfo($event, item) {
            $event.preventDefault()
            item.구매정보여부 = this.productListsinit.find(e => e._id == item._id).구매정보여부;
            item.구매정보 = this.productListsinit.find(e => e._id == item._id).구매정보;
            this.구매정보없음 = this.productLists.filter(e => !e.구매정보여부).length;
            this.구매정보있음 = this.productLists.filter(e => e.구매정보여부).length;
            this.$nextTick(() => {
                this.$bvModal.hide('modalpurchase' + item._id);
            })
        },
        async savePurchaseInfo($event, item) {
            $event.preventDefault()
            // this.showlist = false;
            var 현재구매정보여부 = this.productListsinit.find(e => e._id == item._id).구매정보여부;
            var 현재구매정보 = this.productListsinit.find(e => e._id == item._id).구매정보;

            if (item.구매정보 && item.구매정보.length > 0) {
                var p = this.deepClone(item.구매정보[0]);
                var par = ['매칭상태', '옵션이미지', '상품매칭', '구매링크', '구매링크init', '구매재고', '등록이미지', '옵션이미지', '옵션1_중국어', '옵션2_중국어', '구매sku', '판매구성수량', 'item']
                for (var i = 1; i < item.구매정보.length; i++) {
                    Object.keys(item.구매정보[i]).forEach(e => {
                        if (!par.includes(e)) {
                            item.구매정보[i][e] = p[e];
                        }
                    })
                }
            }


            if (!item.구매정보 || item.구매정보.length == 0 || item.구매정보.find(e => e.매칭상태 !== '매칭완료' || e.요청사항 !== '등록완료')) {
                var 구매정보여부 = false
            } else {
                구매정보여부 = true;
            }

            this.productListsinit.find(e => e._id == item._id).구매정보여부 = 구매정보여부;
            this.productListsinit.find(e => e._id == item._id).구매정보 = item.구매정보;
            item.구매정보여부 = 구매정보여부;

            console.log(item.구매정보)
            console.log(item)
            console.log(this.productListsinit.filter(e => e.productId == item.productId && e.구매정보.find(f => f.요청사항 !== "등록완료")))
            console.log(this.productListsinit.filter(e => e.구매정보.find(f => f.요청사항 !== "등록완료")))




            if (구매정보여부 && this.productListsinit.filter(e => e.productId == item.productId && e.구매정보.find(f => f.요청사항 !== "등록완료")).length > 0) {
                if (confirm('현재 구매정보를 동일한 노출ID에 모두 적용하시겠습니까? 적용대상 : ' + this.productListsinit.filter(e => e.productId == item.productId).length + '개')) {
                    var cnt = 0;
                    for (var e of this.productListsinit.filter(e => e.productId == item.productId)) {
                        if (e.barcode !== item.barcode) {
                            console.log(e)
                            e.구매정보여부 = false;
                            e.구매정보 = [];
                            for (i = 0; i < item.구매정보.length; i++) {
                                e.구매정보[i] = this.deepClone(item.구매정보[i])
                            }
                            for (i = 0; i < e.구매정보.length; i++) {
                                var f = e.구매정보[i];
                                console.log(e.구매정보)
                                f.바코드 = e.barcode;
                                f.상품명 = e.상품명;
                                f.상품명init = e.상품명;
                                f.등록이미지 = e.옵션이미지;
                                f.한글표시사항.제품명 = e.상품명;
                                f.옵션이미지 = undefined;

                                f.옵션1_중국어 = f.상품매칭.옵션1_중국어.length > 0 ? undefined : "";
                                f.옵션2_중국어 = f.상품매칭.옵션2_중국어.length > 0 ? undefined : "";

                                if (f.옵션1_중국어 == undefined || f.옵션2_중국어 == undefined) {
                                    f.매칭상태 = "매칭필요";
                                } else {
                                    f.매칭상태 = "매칭완료";
                                }
                            }
                        }
                        var res = await this.saveImportInfo(e, false);
                        if (res) {
                            cnt++
                            this.$store.commit('growthdbupdateOne', e);
                        }
                        this.구매정보없음 = this.productLists.filter(e => !e.구매정보여부).length;
                        this.구매정보있음 = this.productLists.filter(e => e.구매정보여부).length;
                    }
                    alert(cnt + '개 상품 적용완료')
                } else {
                    res = await this.saveImportInfo(item, true);
                    if (!res) {
                        this.productListsinit.find(e => e._id == item._id).구매정보여부 = 현재구매정보여부;
                        this.productListsinit.find(e => e._id == item._id).구매정보 = 현재구매정보;
                        item.구매정보여부 = 현재구매정보여부;
                        item.구매정보 = 현재구매정보;
                    } else {
                        this.$store.commit('growthdbupdateOne', item);
                    }
                    this.구매정보없음 = this.productLists.filter(e => !e.구매정보여부).length;
                    this.구매정보있음 = this.productLists.filter(e => e.구매정보여부).length;
                }
            } else {
                res = await this.saveImportInfo(item, true);
                if (!res) {
                    this.productListsinit.find(e => e._id == item._id).구매정보여부 = 현재구매정보여부;
                    this.productListsinit.find(e => e._id == item._id).구매정보 = 현재구매정보;
                    item.구매정보여부 = 현재구매정보여부;
                    item.구매정보 = 현재구매정보;
                } else {
                    this.$store.commit('growthdbupdateOne', item);
                }
                this.구매정보없음 = this.productLists.filter(e => !e.구매정보여부).length;
                this.구매정보있음 = this.productLists.filter(e => e.구매정보여부).length;
            }
            this.$bvModal.hide('modalpurchase' + item._id);
            // this.showlist = true;
            // this.$nextTick(() => {
            //     this.searchResult(this.$store.state.growthdb);
            // })

        },
        classPurchaseInfo(item) {
            if (item.구매정보여부) {
                return 'success'
            } else {
                return 'secondary'
            }
        },
        async copyReq(lists) {
            console.log(lists[0])
            var newObj = this.deepClone(lists[0]);
            if (newObj.상품매칭.옵션1_중국어.length > 0) {
                newObj.옵션1_중국어 = undefined;
            } else {
                newObj.옵션1_중국어 = '';
            }
            if (newObj.상품매칭.옵션2_중국어.length > 0) {
                newObj.옵션2_중국어 = undefined;
            } else {
                newObj.옵션2_중국어 = '';
            }
            newObj.상품명init = newObj.상품명
            newObj.옵션이미지 = undefined;
            newObj.매칭상태 = '매칭필요';
            if (!newObj.요청내역.destination) {
                newObj.요청내역.destination = 'coupang'
            }
            if (!newObj.요청내역.customsType) {
                newObj.요청내역.customsType = 'integrated'
            }
            lists.forEach(e => {
                e.묶음구성여부 = true;
                e.묶음구성수량 = lists.length + 1;
            })
            lists.push(newObj);
        },
        addProductName(list) {
            list.상품명 = list.상품명init;
        },
        changeBarcode(item) {
            if (!item.요청내역.barcode) {
                alert('바코드라벨 미부착 시 반드시 원산지가 표시되어 있어야 합니다.')
                item.요청내역.sticker = true;
            } else {
                item.요청내역.sticker = false;
            }
        },
        confirmBarcode(list) {
            if (list.바코드.includes('no') || list.바코드.includes('NO') || list.바코드.includes('No') || list.바코드.includes('노')) {
                if (list.묶음구성여부) {
                    alert('바코드 정보가 없는 경우 묶음구성 진행이 어렵습니다. 바코드를 먼저 생성해 주세요')
                    return
                }
            }
        },
        async importHideProducts() {
            this.showHideProducts = false;
            this.showspinner2 = true;
            // 항상 서버에서 다시 읽는다. 로컬 캐시를 쓰면 방금 숨긴 항목/다른 화면(SCM)에서
            // 숨긴 항목이 반영되지 않는다. 서버는 show:false 요청에 wing 숨김을 넣지 않는다
            // — wing 숨김은 쿠플러스에서 복원할 수 없어 복원 목록에 있으면 안 된다.
            try {
                var res = await axios.post('/api/getGrowthDBV2', { show: false });
                this.searchProducts = res.data.growthdb;
                this.showHideProducts = true;
                this.showspinner2 = false;
            } catch (e) {
                alert('불러오기 실패')
                console.log(e)
                this.showspinner2 = false;
            }
        },
        async saveImport($event, item) {
            $event.preventDefault()
            // this.showlist = false;
            var currentImportInfo = this.productListsinit.find(e => e._id == item._id).매입정보;
            var 현재매입가 = this.productListsinit.find(e => e._id == item._id).매입가;
            var 현재마진 = this.productListsinit.find(e => e._id == item._id).마진;
            var 현재마진율 = this.productListsinit.find(e => e._id == item._id).마진율;
            var 현재ROI = this.productListsinit.find(e => e._id == item._id).ROI;
            var 현재ROAS = this.productListsinit.find(e => e._id == item._id).ROAS;

            this.changeCost(item);
            this.changeMargin(item);
            this.productListsinit.find(e => e._id == item._id).매입정보 = item.매입정보;
            this.productListsinit.find(e => e._id == item._id).매입가 = item.매입가;
            this.productListsinit.find(e => e._id == item._id).마진 = item.마진;
            this.productListsinit.find(e => e._id == item._id).마진율 = item.마진율;
            this.productListsinit.find(e => e._id == item._id).ROI = item.ROI;
            this.productListsinit.find(e => e._id == item._id).ROAS = item.ROAS;

            var res = await this.saveImportInfo(item, true);
            if (!res) {
                this.productListsinit.find(e => e._id == item._id).매입정보 = currentImportInfo;
                this.productListsinit.find(e => e._id == item._id).매입가 = 현재매입가;
                this.productListsinit.find(e => e._id == item._id).마진 = 현재마진;
                this.productListsinit.find(e => e._id == item._id).마진율 = 현재마진율;
                this.productListsinit.find(e => e._id == item._id).ROI = 현재ROI;
                this.productListsinit.find(e => e._id == item._id).ROAS = 현재ROAS;

                item.매입정보 = currentImportInfo;
                item.매입가 = 현재매입가;
                item.마진 = 현재마진;
                item.마진율 = 현재마진율;
                item.ROI = 현재ROI;
                item.ROAS = 현재ROAS;
            } else {
                // 좁은 화면 목록을 공용 스토어에 덮어쓰면 판매장부가 그걸 물려받아
                // 숨김 상품의 과거 매출이 사라진다. 무효화만 하고 다음 소비자가 전량을 다시 받게 한다.
                this.$store.commit('growthdbupdate', []);
            }
            this.매입정보없음 = this.productLists.filter(e => !e.매입가).length;
            this.$nextTick(() => {
                this.$bvModal.hide('modalImport' + item._id);
            })

            // setTimeout(()=>{
            //     this.showlist = true;
            // },10)
        },
        async saveImportInfo(data, bool) {
            try {
                // Save purchase info to PurchaseDB
                const purchaseData = {
                    vendorItemId: data.vendorItemId,
                    구매정보: data.구매정보,
                    매입정보: data.매입정보
                };

                const res = await axios.post('/api/purchasedb/save', purchaseData);

                if (res.data.res !== 'success') {
                    alert('저장실패(901) : ' + res.data.alert);
                    return false;
                } else {
                    if (bool) {
                        alert('저장완료');
                    }
                    return true;
                }
            } catch (e) {
                alert('저장실패(905) : ' + e);
                return false;
            }
        },
        cancelImport(item) {
            item.매입정보 = this.productListsinit.find(e => e._id == item._id).매입정보;
            this.changeCost(item);
            this.changeMargin(item);
            this.매입정보없음 = this.productLists.filter(e => !e.매입가).length;
            this.$nextTick(() => {
                this.$bvModal.hide('modalImport' + item._id);
            })
        },
        // 대표 매입가 = 매입정보 배열의 **가격이 적힌 마지막 행**.
        // 마진·ROI·SCM 재고금액·광고 마진맵이 전부 이 값을 물려 쓴다(SoT).
        //
        // ⚠ 예전엔 그냥 '마지막 행' 이었다. 입고내역이 날짜·수량만 있는 뼈대 행을
        //   깔아주기 시작하면서(정본 §4 lot), 그 행이 맨 뒤에 오면 매입가가 0 이 된다.
        //   같은 이유로 [+ 추가] 가 만드는 빈 행(매입가 0)도 더 이상 대표값을 밀어내지 않는다.
        changeCost(item) {
            const 대표 = 대표매입가(item.매입정보);
            if (대표 > 0) {
                item.매입가 = 대표;
                if (item.returnProducts && item.returnProducts.length > 0) {
                    for (var returnProd of item.returnProducts) {
                        returnProd.매입가 = 대표;
                    }
                }
                if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
                    for (var bundleProd of item.upBundlingProducts) {
                        const bundleSize = bundleProd.upBundlingSize || 1;
                        bundleProd.매입가 = 대표 * bundleSize;
                    }
                }
            } else {
                item.매입가 = "";
                if (item.returnProducts && item.returnProducts.length > 0) {
                    for (var returnProd2 of item.returnProducts) {
                        returnProd2.매입가 = "";
                    }
                }
                if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
                    for (var bundleProd2 of item.upBundlingProducts) {
                        bundleProd2.매입가 = "";
                    }
                }
            }
        },
        milkrunShown(item) {
            // { 상태: '값'|'정보없음'|'해당없음', 원 } — lot 근거값만 쓴다(옛 저장값 폴백 금지, #4)
            const b = (this.$store.state.growthCostBasis || {})[String(item.vendorItemId)];
            return 밀크런표시(b, item.밀크런정보);
        },
        // 마진 칸에 마우스를 올리면 어떤 근거로 계산했는지 보여준다(#112) — 매입가 칸(대표매입가)과 다를 수 있어서
        marginBasisTitle(a) {
            const b = (this.$store.state.growthCostBasis || {})[String(a.vendorItemId)];
            if (!b) return '쿠팡 요율 기준(배송비 개당 1회)';
            const w = v => Math.round(v).toLocaleString();
            const 근거 = { report: '최근 실제 ÷ 순판매', avgQty: '주문당 평균 수량 반영', rate: '쿠팡 요율' }[b.배송비근거] || '';
            return [
                b.매입가 > 0 ? `매입가 ${w(b.매입가)}원 (입고 ${b.입고일} lot)` : '매입가 = 대표매입가',
                `밀크런 ${w(b.밀크런 || 0)}원/개`,
                b.배송비 != null ? `배송비 ${w(b.배송비)}원/개 (${근거}, VAT별도)` : '배송비 = 쿠팡 요율',
                b.입출고비 != null ? `입출고비 ${w(b.입출고비)}원/개 (VAT별도)` : '입출고비 = 쿠팡 요율'
            ].join(' / ');
        },
        changeMargin(item) {
            // 마진 공식은 adDomain.computeMargin 하나(store growthdbupdate 와 같다, #112).
            // basis = 판매장부와 같은 근거(실제 배송비·입출고비 ÷ 순판매, 지금 팔리는 lot 의 매입가·밀크런)
            const basisOf = vid => (this.$store.state.growthCostBasis || {})[String(vid)];
            const milkrun = item.밀크런비용 || 0;
            const setMargin = (a, cost, milk) => {
                const b = basisOf(a.vendorItemId);
                a.마진 = adDomain.computeMargin({ ...a, 매입가: cost, 밀크런비용: milk }, b);
                const totalCost = (b && b.매입가 > 0 ? b.매입가 : cost) + (b && b.밀크런 != null ? b.밀크런 : milk);
                a.마진율 = Math.round(a.마진 / (a.salePrice - a.coupon) * 100) / 100;
                a.ROI = Math.round(a.마진 / (totalCost * 10 / 11) * 100) / 100;
                a.ROAS = Math.round((a.salePrice - a.coupon) / a.마진 * 110) / 100;
            };
            if (!item.매입가) return;
            setMargin(item, item.매입가, milkrun);
            (item.returnProducts || []).forEach(retProd => setMargin(retProd, retProd.매입가, milkrun));
            (item.upBundlingProducts || []).forEach(bunProd => setMargin(bunProd, bunProd.매입가, milkrun * (bunProd.upBundlingSize || 1)));
        },
        formatDate(date) {
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        getTodaywith() {
            var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);
            return year + "-" + month + "-" + day;
        },
        addImportInfo(productList) {
            this.showImport = false;
            if (productList.매입정보) {
                productList.매입정보.push({
                    date: this.getTodaywith(),
                    매입가: 0,
                })
            } else {
                productList.매입정보 = [{
                    date: this.getTodaywith(),
                    매입가: 0,
                }]
            }
            setTimeout(() => {
                this.showImport = true;
                this.editmode = true;
            }, 1)
        },
        changeImportInfo(event) {
            if (event.keyCode == 13) {
                this.editmode = false;
            }
        },
        editImport() {
            if (this.editmode == false) {
                this.editmode = true;
            } else {
                this.editmode = false;
            }
        },
        deleteImport(productList, index) {
            productList.매입정보.splice(index, 1);
        },
        async calMargin(productList) {
            this.showlist = false;
            if (productList.매입가 && productList.매입가 > 0) {
                var 부가세 = productList.판매가 / 11 - productList.수수료 / 11 - productList.매입가 / 11
                productList.마진 = parseInt(productList.판매가 - productList.매입가 - productList.수수료 - 부가세);
                productList.마진율 = Math.round((productList.판매가 - productList.매입가 - productList.수수료 - 부가세) / productList.판매가 * 100 * 10) / 10
                productList.ROI = Math.round((productList.판매가 - productList.매입가 - productList.수수료 - 부가세) / (productList.매입가 * 10 / 11) * 100 * 10) / 10
            } else {
                productList.마진 = '';
                productList.마진율 = '';
                productList.ROI = '';
            }
            setTimeout(() => {
                this.showlist = true;
            }, 1)
        },
        async delManageItems() {
            if (this.tableSelectedItem.length == 0) {
                alert('관리삭제할 항목을 선택해 주세요')
                return
            }
            if (confirm(this.tableSelectedItem.length + '개의 항목을 숨김처리하시겠습니까?')) {
                try {
                    // vendorItemId 로 보낸다. 예전에는 _id 를 보냈는데 서버가 그 _id 로 다른 컬렉션을
                    // 갱신하고 있어 하나도 매칭되지 않았다(화면에서만 사라지고 새로고침하면 돌아왔다).
                    var input = this.tableSelectedItem.map(e => String(e.vendorItemId ?? e.옵션ID));
                    var res = await axios.post('/api/growthdb/hideProduct', input);
                    if (res.data.res == 'success') {
                        this.productLists = this.productLists.filter(e => !input.includes(String(e.vendorItemId ?? e.옵션ID)));
                        this.productListsinit = this.productListsinit.filter(e => !input.includes(String(e.vendorItemId ?? e.옵션ID)));
                        this.searchProducts = this.searchProducts.concat(this.tableSelectedItem);
                        this.tableSelectedItem = [];
                        // 좁은 화면 목록을 공용 스토어에 덮어쓰면 판매장부가 그걸 물려받아
                        // 숨김 상품의 과거 매출이 사라진다. 무효화만 하고 다음 소비자가 전량을 다시 받게 한다.
                        this.$store.commit('growthdbupdate', []);
                    } else {
                        alert(res.data.alert)
                    }
                } catch (e) {
                    alert('err823' + e)
                }
            }
        },
        changePackage(list) {
            if (this.packageMethod == 'opp') {
                list.요청내역.opp = true;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'LDPE') {
                list.요청내역.opp = true;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'noPackage') {
                list.요청내역.opp = false;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'auto') {
                list.요청내역.opp = false;
                list.요청내역.LDPE = false;
                list.요청내역.auto = true;
                return
            }
        },
        async addSearchProduct(list) {
            // CDataTable 슬롯은 item 만 넘겨준다(index 없음). 목록에서 빼는 건 addManage 가
            // 서버 응답을 받은 뒤 vendorItemId 로 처리한다 — 실패했는데 사라지지 않게.
            var f = list;
            // 구매정보여부 는 불리언이고 GrowthDB 문서엔 존재하지도 않는다 — 여기서 .length 를 읽어
            // 클릭할 때마다 TypeError 로 죽었다(화면상 "버튼이 아무 반응 없음"). 서버가 복원 목록의
            // 모든 행에 구매정보:[] 를 채워 보내는데(mergeCatalogWithPurchase) 빈 배열도 truthy 라
            // 항상 뒷단을 평가했다. 판정 대상은 구매정보 자체다.
            if (!f.구매정보 || f.구매정보.length == 0) {
                var 구매정보 = [{
                    checked: false,
                    showspinner: false,
                    // SKUID : '',
                    바코드: f.barcode,
                    상품명: f.productName,
                    상품명init: f.productName,
                    구매링크: undefined,
                    구매링크init: undefined,
                    옵션1_중국어: undefined,
                    옵션2_중국어: undefined,
                    옵션이미지: undefined,
                    매칭상태: '매칭필요',
                    상품매칭: {
                        옵션1_중국어: [],
                        옵션2_중국어: [],
                    },
                    구매재고: '',
                    구매요청수량: '',
                    판매구성수량: 1,
                    묶음구성여부: false,
                    묶음구성수량: '',
                    묶음대상바코드: '',
                    신고영문명: '',
                    신고가격: '',
                    HSCODE: '',
                    진행현황: '구매전',
                    재고동봉: true,
                    등록이미지: f.optionImageUrl,
                    요청사항: '요청등록',
                    reqtype: '제트배송',
                    sizeX: f.sizeInfo ? f.sizeInfo.width : 0,
                    sizeY: f.sizeInfo ? f.sizeInfo.length : 0,
                    sizeZ: f.sizeInfo ? f.sizeInfo.heigth : 0,
                    weight: f.sizeInfo ? f.sizeInfo.weight : 0,
                    요청내역: {
                        default: true,
                        poarrange: false,
                        한글표시사항: true,
                        barcode: true,
                        sticker: false,
                        stamp: false,
                        tag: false,
                        reqcontent: '',
                        reqcontentPurchase: '',
                        opp: false,
                        LDPE: false,
                        airpacking: false,
                        exportType: 'box',

                        masking: false,
                        destination: 'coupang',
                        auto: true,
                        customsType: 'integrated',
                    },
                    한글표시사항: {
                        제품명: f.productName,
                        '수입원/판매원': '',
                        제조원: '',
                        제조국: '',
                        내용량: '',
                        '원료명및성분명(재질)': '',
                        상품유형: '',
                        사용시주의사항: '',
                        사용기준: '',
                        custom: '',
                        kc인증: false,
                        식품용: false,
                    },
                    polists: [],
                    selectpo: '',
                }];
                var 구매정보여부 = false
            }
            var obj = {
                _id: f._id,
                상품명: f.상품명 ? f.상품명 : f.productName,
                바코드: f.바코드 ? f.바코드 : f.barcode,
                노출ID: f.노출ID ? f.노출ID : f.productId,
                옵션ID: f.옵션ID ? f.옵션ID : f.vendorItemId,
                승인상태: f.승인상태 ? f.승인상태 : f.statusName,
                옵션이미지: f.옵션이미지 ? f.옵션이미지 : f.optionImageUrl,

                구매정보: f.구매정보 || 구매정보,
                구매정보여부: f.구매정보여부 || 구매정보여부,
                판매링크: f.판매링크 ? f.판매링크 : 'https://www.coupang.com/vp/products/' + f.productId + '?vendorItemId=' + f.vendorItemId,
                아이템위너: f.아이템위너 ? f.아이템위너 : f.winner,
                뱃지: f.뱃지 ? f.뱃지 : f.badge,
                // 목록·뱃지·표 컬럼은 전부 원본 필드명(winner/badge)을 읽는다. 한글 이름만
                // 담으면 복원된 행이 집계에서 통째로 빠지고 표에서도 빈칸으로 보인다.
                winner: f.winner ? f.winner : f.아이템위너,
                badge: f.badge ? f.badge : f.뱃지,

                사이즈: f.사이즈 ? f.사이즈 : f.size,
                사이즈정보: f.사이즈정보 ? f.사이즈정보 : f.sizeInfo,
                판매가: f.판매가 ? f.판매가 : f.salePrice,

                풀필먼트수수료: f.풀필먼트수수료 ? f.풀필먼트수수료 : f.fullfillmentFee,
                입출고수수료: f.입출고수수료 ? f.입출고수수료 : f.warehouseFee,
                판매수수료: f.판매수수료 ? f.판매수수료 : f.commision,
                판매수수료율: f.판매수수료율 ? f.판매수수료율 : f.commisionRate,
                수수료: f.수수료 ? f.수수료 : ((parseInt(f.fullfillmentFee) + parseInt(f.warehouseFee) + f.commision) * 1.1).toFixed(0),

                매입정보: f.매입정보 || [],
                매입가: f.매입가 || "",
                마진: f.마진 || "",
                마진율: f.마진율 || "",
                ROI: f.ROI || "",
                ROAS: f.ROAS || ""
            }

            // 목록에 실제로 담긴 뒤에 다시 세야 한다. addManage 는 서버 응답을 기다렸다가
            // push 하므로, await 하지 않으면 push 전 목록을 세게 된다.
            await this.addManage(obj);
            this.calculateCounts();
            this.showlist = true;
            this.showspinner = false;
            this.showspinner1 = false;
            // this.productList = list;
        },
        delSearchProduct(list) {
            delete list.add;
        },
        async addManage(item) {
            // GrowthDB 문서의 옵션ID 필드는 vendorItemId 다. 예전 코드는 item.옵션ID 를 읽어
            // undefined 를 보내고 있었다(복원이 동작하지 않던 원인 중 하나).
            var vendorItemId = String(item.vendorItemId ?? item.옵션ID);
            try {
                var res = await axios.post('/api/growthdb/showProduct', [vendorItemId])
                if (res.data.res == 'success') {
                    this.searchProducts = this.searchProducts.filter(e => String(e.vendorItemId ?? e.옵션ID) !== vendorItemId);
                    this.productLists.push(item)
                    this.productListsinit.push(this.deepClone(item))
                    // 좁은 화면 목록을 공용 스토어에 덮어쓰면 판매장부가 그걸 물려받아
                    // 숨김 상품의 과거 매출이 사라진다. 무효화만 하고 다음 소비자가 전량을 다시 받게 한다.
                    this.$store.commit('growthdbupdate', []);
                } else {
                    alert(res.data.alert)
                }
            } catch (e) {
                console.log('err844' + e);
            }
        },
        delAddProduct(index) {
            this.addProducts.splice(index, 1);
        },
        confirmlist(list) {
            if (!list.바코드) {
                if (!confirm('바코드가 없는 경우 로켓그로스 출고가 불가능합니다.')) {
                    return false
                }
            }
            if (!list.신고영문명) {
                alert("요청내역 중 신고영문명을 작성해주세요. ex)여성신발 -> women's shoes ")
                return false
            }
            // if(!list.신고가격){
            //     alert("요청내역 중 신고가격을 USD로 환산하여 작성해주세요. ex) 2달러 -> 2 ")
            //     return false
            // }            
            if (!list.HSCODE) {
                alert("요청내역 중 HS-CODE를 작성해주세요. ex) 6303.92-0000 ")
                return false
            }
            if (list.HSCODE.length !== 12) {
                alert("HS-CODE를 Full name으로 작성해주세요. ex) 6303.92-0000 ")
                return false
            }
            if (list.구매요청수량 == 0 || !list.구매요청수량) {
                alert("구매요청수량을 작성해 주세요.")
                return false
            }
            if (list.판매구성수량 == 0 || !list.판매구성수량) {
                alert("판매구성수량을 작성해 주세요.")
                return false
            }
            list.한글표시사항.제품명 = list.상품명;
            // 필수 텍스트 항목만 화이트리스트로 검사 (kc인증/식품용 등 boolean·선택 키가 추가돼도 오탐 안 나게)
            var 필수표시항목 = ['수입원/판매원', '제조원', '제조국', '내용량', '원료명및성분명(재질)', '상품유형', '사용시주의사항', '사용기준'];
            if (필수표시항목.some(k => !list.한글표시사항[k])) {
                console.log(list.한글표시사항)
                alert('한글표시사항을 모두 작성해 주세요')
                return false
            }
            return true
        },
        async savereq($event, list, index) {
            $event.preventDefault();
            var foo = this.confirmlist(list)
            if (!foo) {
                return
            }
            list.요청사항 = '등록완료';
            console.log(list)

            this.$nextTick(() => {
                this.$bvModal.hide('modalreq' + index);
                console.log('modalreq' + index)
            })


        },
        // regrequest(list,index){
        //     if(!list.상품명){
        //         alert('상품명을 먼저 입력해 주세요')
        //         return
        //     }
        //     this.$bvModal.show('modalreq' + index);
        // },
        async addlists(item) {
            var obj = {
                checked: false,
                showspinner: false,
                // SKUID : '',
                바코드: item.바코드,
                상품명: item.상품명,
                상품명init: item.상품명,
                구매링크: undefined,
                구매링크init: undefined,
                옵션1_중국어: undefined,
                옵션2_중국어: undefined,
                옵션이미지: undefined,
                매칭상태: '매칭필요',
                상품매칭: {
                    옵션1_중국어: [],
                    옵션2_중국어: [],
                },
                구매재고: '',
                구매요청수량: '',
                판매구성수량: 1,
                묶음구성여부: false,
                묶음구성수량: '',
                묶음대상바코드: '',
                신고영문명: '',
                신고가격: '',
                HSCODE: '',
                진행현황: '구매전',
                재고동봉: true,
                등록이미지: item.옵션이미지,
                요청사항: '요청등록',
                reqtype: '제트배송',
                sizeX: item.sizeInfo ? item.sizeInfo.width : "",
                sizeY: item.sizeInfo ? item.sizeInfo.length : "",
                sizeZ: item.sizeInfo ? item.sizeInfo.heigth : "",
                weight: item.sizeInfo ? item.sizeInfo.weight : "",
                요청내역: {
                    default: true,
                    poarrange: false,

                    한글표시사항: true,
                    barcode: true,
                    sticker: false,
                    sewing: false,
                    stamp: false,
                    tag: false,
                    reqcontent: '',
                    reqcontentPurchase: '',
                    opp: false,
                    LDPE: false,
                    airpacking: false,
                    exportType: 'box',
                    destination: 'coupang',
                    masking: false,
                    auto: true,
                    customsType: 'integrated'
                },
                한글표시사항: {
                    제품명: item.상품명,
                    '수입원/판매원': '',
                    제조원: '',
                    제조국: '',
                    내용량: '',
                    '원료명및성분명(재질)': '',
                    상품유형: '',
                    사용시주의사항: '',
                    사용기준: '',
                    custom: '',
                    kc인증: false,
                    식품용: false,
                },
                polists: [],
                selectpo: '',
            }
            item.구매정보.push(obj)
        },
        toggleCollapse(item) {
            if (this.isCollapseOpen) {
                this.purchaseItem.purchaseInfoLists = [];
            } else {
                this.purchaseItem = this.deepClone(item);
            }
            this.isCollapseOpen = !this.isCollapseOpen;
        },
        deepClone(obj) {
            if (obj === null || typeof obj !== "object") {
                return obj
            }

            const result = Array.isArray(obj) ? [] : {}

            for (let key of Object.keys(obj)) {
                result[key] = this.deepClone(obj[key])
            }

            return result
        },
        collectGrowthDb() {
            // [수집로직 일원화] manualCollect로 통합 - Extension이 서버에서 데이터 조회 후 수집
            this.beginOwnCollection();
            window.postMessage({
                greeting: "manualCollect",
                itemKey: "rocketGrowthProducts",
                companyid: this.$store.state.user.companyid,
                suppliercode: this.$store.state.user.suppliercode,
                options: {}
            }, "*");
            this.showspinner1 = true;
            this.showlist = false;
            return;

            /* [수집로직 일원화] 아래 기존 코드는 비활성화 (manualCollect로 대체)
            if (!total) {
                var updatedb = this.tableSelectedItem.map(e => {
                    return {
                        productId: e.productId,
                        vendorItemId: e.vendorItemId,
                        itemId: e.itemId,
                        salePrice: e.salePrice,
                        coupon: e.coupon,
                        badge: e.badge,
                        barcode: e.barcode,
                        sizeInfo: e.sizeInfo,
                    }
                })
                if (updatedb.length > 0) {
                    var growthdb = []
                } else {
                    growthdb = this.$store.state.growthdb.map(e => {
                        return {
                            productId: e.productId,
                            vendorItemId: e.vendorItemId,
                            itemId: e.itemId,
                            salePrice: e.salePrice,
                            coupon: e.coupon,
                            badge: e.badge,
                            barcode: e.barcode,
                            sizeInfo: e.sizeInfo,
                        }
                    })
                }
            } else {
                updatedb = [];
                growthdb = [];
            }

            // 허용 vendorName 정보 가져오기
            const allowedVendorNames = this.$store.state.settings && this.$store.state.settings[0] && this.$store.state.settings[0].allowedVendorNames
                ? this.$store.state.settings[0].allowedVendorNames
                : [];

            window.postMessage({
                greeting: "collectGrowthDb",
                companyid: this.$store.state.user.companyid,
                suppliercode: this.$store.state.user.suppliercode,
                detailSize: true,
                growthdb: growthdb,
                updatedb: updatedb,
                allowedVendorNames: allowedVendorNames
            }, "*")
            this.showspinner1 = true;
            this.showlist = false;
            */
        },
        barcodegap(index, total) {
            if (index < total) {
                return 'border:0px solid silver;width:300px;text-align: center;margin-bottom:' + this.바코드간격 + 'px'
            } else {
                return 'border:0px solid silver;width:300px;text-align: center;'
            }
        },
        printbarcoderef() {
            if (this.바코드출력 != '') {
                this.printbarcode(this.바코드출력)
                // this.바코드출력 = ''
            } else {
                if (this.SKU출력 != '') {
                    var barcode = this.$store.state.productdb.find(e => e["SKU ID"] == this.SKU출력).바코드
                    this.printbarcode(barcode);
                    // this.SKU출력 = ''
                }
            }
        },
        printbarcodewith(event) {
            if (event.keyCode === 13) {
                this.printbarcode(event.target.value)
                // this.바코드출력 = ''
            }
        },
        printSKUwith(event) {
            if (event.keyCode === 13) {
                var barcode = this.$store.state.productdb.find(e => e["SKU ID"] == event.target.value).바코드
                this.printbarcode(barcode);
                // this.SKU출력 = ''
            }
        },
        printbarcode(barcode) {
            if (this.$store.state.productdb.length > 0 && this.$store.state.productdb.find(e => e.바코드 == barcode)) {
                var ob = this.$store.state.productdb.find(e => e.바코드 == barcode)
                this.출력SKUID = ob['SKU ID'];
                this.출력바코드 = barcode;
                this.출력상품명 = ob['상품명'];
                this.한글표시사항 = {
                    '수입원/판매원': ob['수입원/판매원'],
                    제조원: ob.제조원,
                    제조국: ob.제조국,
                    내용량: ob.내용량,
                    '원료명및성분명(재질)': ob['원료명및성분명(재질)'],
                    상품유형: ob.상품유형,
                    사용시주의사항: ob.사용시주의사항,
                    사용기준: ob.사용기준,
                }
                setTimeout(() => {
                    this.print('printMe8');
                }, 10)
            }

        },
        printBarcodeFromPurchase(list) {
            this.출력바코드 = list.바코드;
            this.출력상품명 = list.상품명;
            this.한글표시사항 = {
                '수입원/판매원': list.한글표시사항?.['수입원/판매원'] || '',
                제조원: list.한글표시사항?.제조원 || '',
                제조국: list.한글표시사항?.제조국 || '',
                내용량: list.한글표시사항?.내용량 || '',
                '원료명및성분명(재질)': list.한글표시사항?.['원료명및성분명(재질)'] || '',
                상품유형: list.한글표시사항?.상품유형 || '',
                사용시주의사항: list.한글표시사항?.사용시주의사항 || '',
                사용기준: list.한글표시사항?.사용기준 || '',
                custom: list.한글표시사항?.custom || '',
                kc인증: list.한글표시사항?.kc인증 || false,
                식품용: list.한글표시사항?.식품용 || false,
            };
            this.printkcenable = list.한글표시사항?.kc인증 || false;
            this.printfoodenable = list.한글표시사항?.식품용 || false;
            this.출력수량 = 1;
            setTimeout(() => {
                this.print('printMe8');
            }, 10);
        },
        async print(id) {
            // Pass the element id here
            var options = {
                name: '_blank',
                autoClose: true,
            }
            await this.$htmlToPaper(id, options);
        },
        excelDownFunc() {
            // 사이즈명 한글 변환
            // 다운로드쿠폰 조건 — 엑셀은 화면 축약표기 대신 풀어서 쓴다
            const 다운로드쿠폰조건엑셀 = (info) => {
                if (!info) return '';
                const parts = [];
                if (info.minPrice > 0) parts.push(info.minPrice.toLocaleString() + '원 이상 구매');
                if (info.maxPerDaily > 0) parts.push('하루 ' + info.maxPerDaily + '회');
                return parts.join(', ');
            };

            const getSizeName = (sizeName) => {
                switch (sizeName) {
                    case 'MINI': return '극소형';
                    case 'SMALL': return '소형';
                    case 'MEDIUM': return '중형';
                    case 'LARGE1': return '대형1';
                    case 'LARGE2': return '대형2';
                    default: return '특대형';
                }
            };

            // 한 행을 만든다. source 는 부모/반품/번들 중 하나이고, 상품명은 하위 상품에 없으므로
            // 부모(parent) 것을 쓴다. 구분 라벨은 새제품/반품-최상/번들x2 형태.
            const buildRow = (source, parent, 상품구분) => ({
                '상품구분': 상품구분,
                '상품명': parent.상품명 || parent.productName || '',
                '노출ID': source.productId || '',
                '옵션ID': source.vendorItemId || '',
                '바코드': source.barcode || '',
                // winner 는 'WINNER'/'LOSER'/'FILTERED_OUT'/빈값 네 가지다. 예전 `winner ? 'Y':'N'`
                // 은 문자열이면 무조건 참이라 **루저 18,668건과 FILTERED_OUT 26,084건이 'Y'(위너)로**
                // 내려갔다.
                //
                // **화면 칸(winnerLabel)과 똑같은 값을 내린다.** 엑셀만 Y/N 두 가지로 접으면
                // 어느 쪽으로 접든 거짓말이 된다 — 'N'(루저)으로 접으면 가격을 손보라는 뜻이 돼
                // 잘못 조치하고, 빈칸으로 접으면 '모름'과 섞여 26,084건이 다시 통째로 안 보인다.
                // 판매중지와 품절은 조치가 정반대라 엑셀에서도 갈라 놔야 거르는 의미가 있다.
                // WINNER/LOSER 는 기존 Y/N 을 그대로 둔다(쓰던 수식이 깨지지 않게).
                // 빈값/null 만 '모름'이라 빈칸으로 둔다.
                '아이템위너': source.winner === 'WINNER' ? 'Y'
                    : this.isItemLoser(source) ? 'N'
                        : source.winner === 'FILTERED_OUT' ? this.winnerLabel(source) : '',
                '뱃지': source.badge ? 'Y' : 'N',
                '사이즈': getSizeName(source.수수료?.sizeName),
                '쿠팡재고': source.orderableQuantity || 0,
                '판매가': source.salePrice || 0,
                '할인쿠폰': source.coupon || 0,
                '다운로드쿠폰': source.downloadCouponInfo?.discount || 0,
                '다운로드쿠폰조건': 다운로드쿠폰조건엑셀(source.downloadCouponInfo),
                '수수료합계': source.commission ? parseInt(source.commission * 1.1) : 0,
                '풀필먼트수수료': source.수수료?.배송비 ? Math.round(source.수수료.배송비 * 1.1) : 0,
                '입출고수수료': source.수수료?.입출고비 ? Math.round(source.수수료.입출고비 * 1.1) : 0,
                '판매수수료': source.수수료?.판매수수료 ? Math.round(source.수수료.판매수수료 * 1.1) : 0,
                '판매수수료율(%)': source.수수료?.판매수수료율 ? Math.round(source.수수료.판매수수료율 * 1.1 * 100) / 100 : 0,
                '매입가': source.매입가 || '',
                '마진': source.마진 || '',
                '마진율': source.마진율 || '',
                'ROI': source.ROI || '',
                '최소ROAS': source.ROAS || '',
                '7일매출': source.gmvForLast7Days || 0,
                '30일매출': source.gmvForLast30Days || 0,
                '7일판매량': source.unitsSoldForLast7Days || 0,
                '30일판매량': source.unitsSoldForLast30Days || 0,
            });

            // 화면에서 반품/번들은 별도 행이 아니라 부모 행 셀 안의 덧줄로 그려진다(템플릿 v-for).
            // 엑셀은 셀 안에 줄을 못 쌓으므로 부모 행 아래에 하위 행으로 펼쳐서 내보낸다.
            const excelData = this.productLists.flatMap(item => {
                const rows = [buildRow(item, item, this.getSkuGradeLabel(item.skuGrade))];
                if (this.showReturnProducts && item.returnProducts && item.returnProducts.length > 0) {
                    item.returnProducts.forEach(sub => {
                        rows.push(buildRow(sub, item, this.getSkuGradeLabel(sub.skuGrade)));
                    });
                }
                if (this.showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0) {
                    item.upBundlingProducts.forEach(sub => {
                        rows.push(buildRow(sub, item, '번들x' + (sub.upBundlingSize || 1)));
                    });
                }
                return rows;
            });

            var dataWS = XLSX.utils.json_to_sheet(excelData);

            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS, 'RocketGrowthDB');
            // 엑셀 파일을 내보낸다.
            XLSX.writeFile(wb, 'RocketGrowthDB.xlsx');
        },
        excelDateToJSDate(excelDate) {
            // 이미 문자열 형식의 날짜인 경우 (예: "2025-01-01")
            if (typeof excelDate === 'string') {
                // YYYY-MM-DD 형식인지 확인
                const datePattern = /^\d{4}-\d{2}-\d{2}$/;
                if (datePattern.test(excelDate)) {
                    return excelDate;
                }
                // 다른 문자열 형식이면 Date로 파싱 시도
                const parsedDate = new Date(excelDate);
                if (!isNaN(parsedDate.getTime())) {
                    return this.formatDate(parsedDate);
                }
            }

            // 숫자 형식의 엑셀 날짜인 경우 (엑셀은 1900-01-01 기준이며, JavaScript는 1970-01-01 기준)
            if (typeof excelDate === 'number') {
                const excelEpoch = new Date(1899, 11, 30); // 1899-12-30
                const jsDate = new Date(excelEpoch.getTime() + (excelDate - 1 + 1) * 24 * 60 * 60 * 1000);
                console.log(jsDate);
                return this.formatDate(jsDate);
            }

            // 그 외의 경우 오늘 날짜 반환
            console.warn('Invalid date format:', excelDate);
            return this.getTodaywith();
        },
        formatDownload(matchType = 'vendorItemId') {
            var arr = [];
            var myHeader, fileName, sheetName;

            if (matchType === 'barcode') {
                myHeader = ["바코드", '매입일자(2025-01-01)', '매입가'];
                fileName = '매입가업로드양식_바코드매칭.xlsx';
                sheetName = '매입가업로드양식_바코드';
            } else {
                myHeader = ["옵션ID", '매입일자(2025-01-01)', '매입가'];
                fileName = '매입가업로드양식_옵션ID매칭.xlsx';
                sheetName = '매입가업로드양식_옵션ID';
            }

            var dataWS = XLSX.utils.json_to_sheet(arr, { header: myHeader });

            const range = XLSX.utils.decode_range(dataWS['!ref']);
            range.e['c'] = myHeader.length - 1;
            dataWS['!ref'] = XLSX.utils.encode_range(range);

            var wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, sheetName);
            // 엑셀 파일을 내보낸다.
            XLSX.writeFile(wb, fileName);
        },
        edit(ProductList) {
            this.$store.state.productdb.some(e => {
                if (e["SKU ID"] == ProductList["SKU ID"]) {
                    e.등록이미지 = ProductList.등록이미지;
                    e.구매링크 = ProductList.구매링크;
                    e.옵션1_중국어 = ProductList.옵션1_중국어;
                    e.옵션2_중국어 = ProductList.옵션2_중국어;
                    e.판매구성수량 = ProductList.판매구성수량;
                    e.구매가능상태 = ProductList.구매가능상태;
                    axios.post('/api/addproduct/editproductdb', ProductList)
                        .then((res) => { console.log(res.data.요청결과) })
                        .catch(console.log)
                    return (e["SKU ID"] == ProductList["SKU ID"])
                }
            })
        },
        MenuUpdate() {
            console.log(this.selected)
            if (this.selected == "radio1") {
                this.menuint = this.menuDefault;
            } else {
                if (this.selected == "radio2") {
                    this.menuint = this.menuCost;
                }
                //  else {
                //     this.menuint = this.menuSales;
                // }
            }
        },
        modalID(index) {
            return 'modal' + index
        },
        modaledit(index) {
            return 'modaledit' + index
        },
        searchpd(event) {
            if (event.keyCode === 13) {
                this.search();
            }
        },
        async search() {
            this.showlist = false;
            this.showspinner = true;
            if (this.$store.state.growthdb.length == 0) {
                try {
                    // show 를 보내지 않는다 — 스토어에는 숨김 포함 전량이 들어가야 한다.
                    // 서버는 show 파라미터와 무관하게 통합 판정으로 e.show 를 정확히 채워 보내므로
                    // (server.js:16724) 숨김은 catalogOnly() 에서 화면 단으로 거른다.
                    var result = await axios.post('/api/getGrowthDBV2');
                    this.$store.commit('growthdbupdate', result.data.growthdb);
                    // 개별마진 근거값(#112) — growthdbupdate 가 요청을 띄우고, 들어오면 store 가 마진을 다시 계산한다.
                    // 옛 요율식 값이 화면에 먼저 보이지 않게 목록은 그 뒤에 그린다
                    await this.$store.dispatch('waitGrowthCostBasis');
                    this.searchResult(this.catalogOnly(this.$store.state.growthdb));
                    this.showlist = true;
                    this.showspinner = false;
                } catch (e) {
                    alert('불러오기 실패')
                    console.log(e)
                }
            } else {
                // 다른 화면이 store 를 먼저 채웠어도 근거값이 들어온 뒤의 마진으로 그린다(#112)
                try { await this.$store.dispatch('waitGrowthCostBasis'); } catch (e) { console.error('개별마진 근거값 대기 실패:', e); }
                // alert('수집된 상품DB가 없습니다. 로켓그로스 상품DB 수집을 진행해 주세요.(쿠팡wing 로그인 필수)')
                this.searchResult(this.catalogOnly(this.$store.state.growthdb));
                this.showlist = true;
                this.showspinner = false;
            }
        },
        // 상품관리 목록은 카탈로그(GrowthDB)에 있는 상품만 보여준다.
        // getGrowthDBV2 는 GrowthDB ∪ PurchaseDB 합집합을 주는데, 이는 판매장부·광고가
        // "판 적 있는 모든 옵션"을 필요로 해서지(카탈로그가 누락돼도 판매가 사라지지 않게 — ab0f7132b)
        // 상품관리에 보여주려던 게 아니다. 합집합 행(catalogMissing)은 vendorItemId·매입정보뿐이라
        // 상품명조차 없고, 수집이 hiddenStatus:VISIBLE 기반이라 wing 에서 숨긴 상품이 이 경로로 되살아난다.
        // 실측(rubycoco): 목록 775행 중 641행이 catalogMissing, 그중 640건이 wing 숨김 상품.
        // state.growthdb 는 화면 간 공유되고 판매장부는 length==0 일 때만 다시 로드하므로
        // (growthSalesLedger.vue:1340) 스토어는 합집합 그대로 두고 이 화면에서만 걸러야 한다.
        //
        // 숨김도 같은 이유로 여기서 거른다. 예전에는 서버에 show:true 를 보내 좁은 목록을 받아
        // 그대로 스토어에 커밋했는데, 상품관리를 먼저 들르면 판매장부가 그 좁은 목록을 물려받아
        // 숨긴 상품의 과거 매출이 통째로 사라졌다(실측 33개사 1.38억원, 한 계정은 45% 증발).
        //   e.show === false         : 쿠플러스 자체 숨김 (서버가 세 컬렉션 합집합으로 판정해 채워준다)
        //   e.coupangHidden === true : wing 재고현황 숨김
        // 화면에 내보낼 기준 목록. "반품상품보기" 가 꺼져 있으면 최상위로 올라온 반품등급 행도 감춘다.
        // 부모에 매달린 반품 옵션은 각 행 안에서 v-if 로 접히는데, 단독 행은 자기가 한 줄이라
        // 목록에서 빼야 토글 의미가 맞는다(실측: onsell 은 101행 중 51행이 반품이라 목록 절반이 반품이었다).
        visibleInit() {
            if (this.showReturnProducts) return this.productListsinit;
            return this.productListsinit.filter(e => !(e.skuGrade && e.skuGrade !== 'NEW'));
        },
        // 반품 관련 행 판정. 목록에 들어오는 모양이 두 가지다.
        //   ① 반품 옵션을 아래에 거느린 새제품 행 (returnProducts 가 있다)
        //   ② 붙일 새제품 행을 못 찾아 자기가 최상위로 올라온 반품등급 행 (skuGrade !== 'NEW')
        // ② 는 returnProducts 가 비어 있어 예전 조건에서 빠졌다 — 뱃지는 '반품-최상' 인데
        // 반품 필터를 누르면 목록에서 사라지는 상태였다.
        isReturnRow(e) {
            return (e.returnProducts && e.returnProducts.length > 0) || (e.skuGrade && e.skuGrade !== 'NEW');
        },
        // 상품등급 라벨. 수집이 NEW 부모에 흡수시키지 못한 반품등급 상품을 최상위 문서로 보존하므로
        // (background.js `_orphanReturns`) 최상위 행에도 '새제품' 을 하드코딩하면 안 된다.
        // 실측(2026-08-11): 그렇게 올라온 행이 613개/26개사였고 전부 새제품으로 표시되고 있었다.
        // 라벨 문구는 판매장부(growthSalesLedger.vue getSkuGradeLabel)와 맞춘다.
        getSkuGradeLabel(skuGrade) {
            if (!skuGrade || skuGrade === 'NEW') return '새제품';
            if (skuGrade === 'PACKAGE_DAMAGED') return '반품-미개봉';
            if (skuGrade === 'RETURN_BEST') return '반품-최상';
            if (skuGrade === 'RETURN_GOOD') return '반품-상';
            if (skuGrade === 'RETURN_NORMAL') return '반품-중';
            return skuGrade;
        },
        catalogOnly(list) {
            return (list || []).filter(e => !e.catalogMissing && e.show !== false
                && (this.showCoupangHidden || e.coupangHidden !== true));
        },

        async searchResult(list) {
            console.log(list);
            this.productLists = [];
            this.productListsinit = [];
            this.searchProducts = [];

            for (var e of list) {
                // 반품행에 보이는 옵션ID/노출ID/바코드는 e.returnProducts 안쪽(한 겹 아래)에 있는데
                // CDataTable 검색은 Object.values(item) 으로 최상위 필드만 훑어서 안 잡힌다.
                // 검색 전용 평문 필드로 펼쳐둔다(헤더에 없으므로 컬럼/필터/엑셀에는 안 나옴).
                e.반품검색 = (e.returnProducts || [])
                    .map(a => [a.vendorItemId, a.productId, a.barcode].filter(v => v != null && v !== '').join(' '))
                    .join(' ');
                e.묶음검색 = (e.upBundlingProducts || [])
                    .map(a => [a.vendorItemId, a.productId, a.barcode].filter(v => v != null && v !== '').join(' '))
                    .join(' ');

                if (e.구매정보.length > 0 && !e.구매정보.find(f => f.매칭상태 !== '매칭완료' || f.요청사항 !== '등록완료')) {
                    e.구매정보여부 = true;
                } else {
                    e.구매정보여부 = false;
                    if (e.구매정보 && e.구매정보.length > 0) {
                        e.구매정보.forEach(f => {
                            f.상품명 = e.skuName;
                            f.상품명init = e.skuName;
                            f.등록이미지 = f.등록이미지 || e.imgUrl;
                            f.바코드 = f.바코드 || e.barcode;
                            f.sizeX = e.skuInfo ? e.skuInfo.width : 0;
                            f.sizeY = e.skuInfo ? e.skuInfo.length : 0;
                            f.sizeZ = e.skuInfo ? e.skuInfo.heigth : 0;
                            f.weight = e.skuInfo ? e.skuInfo.weight : 0;
                            f.한글표시사항.제품명 = e.skuName;
                            f.요청내역.customsType = f.요청내역.customsType || 'integrated';
                        })
                    } else {
                        e.구매정보 = [{
                            checked: false,
                            showspinner: false,
                            // SKUID : '',
                            바코드: e.barcode,
                            상품명: e.skuName,
                            상품명init: e.skuName,
                            구매링크: undefined,
                            구매링크init: undefined,
                            옵션1_중국어: undefined,
                            옵션2_중국어: undefined,
                            옵션이미지: undefined,
                            매칭상태: '매칭필요',
                            상품매칭: {
                                옵션1_중국어: [],
                                옵션2_중국어: [],
                            },
                            구매재고: '',
                            구매요청수량: '',
                            판매구성수량: 1,
                            묶음구성여부: false,
                            묶음구성수량: '',
                            묶음대상바코드: '',
                            신고영문명: '',
                            신고가격: '',
                            HSCODE: '',
                            진행현황: '구매전',
                            재고동봉: true,
                            등록이미지: e.imgUrl,
                            요청사항: '요청등록',
                            reqtype: '제트배송',
                            sizeX: e.skuInfo ? e.skuInfo.width : 0,
                            sizeY: e.skuInfo ? e.skuInfo.length : 0,
                            sizeZ: e.skuInfo ? e.skuInfo.heigth : 0,
                            weight: e.skuInfo ? e.skuInfo.weight : 0,
                            요청내역: {
                                default: true,
                                poarrange: false,
                                한글표시사항: true,
                                barcode: true,
                                sticker: false,
                                stamp: false,
                                tag: false,
                                reqcontent: '',
                                reqcontentPurchase: '',
                                opp: false,
                                LDPE: false,
                                airpacking: false,
                                exportType: 'box',

                                masking: false,
                                destination: 'coupang',
                                auto: true,
                                customsType: 'integrated'
                            },
                            한글표시사항: {
                                제품명: e.skuName,
                                '수입원/판매원': '',
                                제조원: '',
                                제조국: '',
                                내용량: '',
                                '원료명및성분명(재질)': '',
                                상품유형: '',
                                사용시주의사항: '',
                                사용기준: '',
                                custom: '',
                                kc인증: false,
                                식품용: false,
                            },
                            polists: [],
                            selectpo: '',
                        }];
                    }
                }
            }

            this.productListsinit = this.deepClone(list);
            // 초기 목록도 "반품상품보기" 토글을 반영한다
            this.productLists = this.visibleInit();

            // 판매장부에서 '매입가 입력하러 가기'로 넘어온 경우 바로 그 상품만 보여준다
            this.$nextTick(() => this.applyLedgerHandoff());

            this.calculateCounts();

            this.showlist = true;
            this.showspinner = false;
            this.showspinner1 = false;
        },

        // 뱃지 숫자는 **여기 하나에서만** 만든다.
        // 예전에는 「숨김처리취소」 쪽(addSearchProduct)이 자기만의 식으로 다시 세다가
        // 숫자를 0으로 만들었다. 세는 곳이 둘이면 반드시 갈라진다.
        //
        // '전체' 뱃지는 실제로 보이는 행 수와 맞춘다(토글 OFF 면 반품행이 빠진다).
        // 나머지 카운트는 전체 기준을 유지한다 — 특히 반품 카운트가 토글에 따라 0이 되면
        // 반품이 있다는 사실 자체를 알 수 없어 누를 수가 없다.
        calculateCounts() {
            this.total = this.productLists.length;
            this.뱃지없음 = this.productListsinit.filter(e => !e.badge).length;
            this.아이템루저 = this.productListsinit.filter(e => this.isItemLoser(e)).length;
            this.판매중지 = this.productListsinit.filter(e => this.isSaleSuspended(e)).length;
            this.품절 = this.productListsinit.filter(e => this.isSoldOut(e)).length;
            this.구매정보없음 = this.productListsinit.filter(e => !e.구매정보여부).length;
            this.반품정보있음 = this.productListsinit.filter(e => this.isReturnRow(e)).length;
            this.번들정보있음 = this.productListsinit.filter(e => e.upBundlingProducts && e.upBundlingProducts.length > 0).length;
            this.구매정보있음 = this.productListsinit.filter(e => e.구매정보여부).length;
            this.매입정보없음 = this.productListsinit.filter(e => !e.매입가).length;

            // 7일 이내 노출ID 변경된 상품 수 계산
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

            this.노출ID변경 = this.productLists.filter(e => {
                if (!e.productIdHistory || e.productIdHistory.length === 0) return false;

                // 7일 이내에 변경된 이력이 있는지 확인
                return e.productIdHistory.some(history =>
                    new Date(history.date) >= sevenDaysAgo
                );
            }).length;

            // 타사매칭 상품 수 계산
            this.타사매칭 = this.productLists.filter(e => {
                return e.otherSellers && e.otherSellers.hasOtherSellers;
            }).length;
        },
        showtotal() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.visibleInit();
                this.showlist = true;
            }, 1);
        },
        // 매입가가 없는 상품만 (판매장부에서 넘어올 때 사용)
        //
        // 판매장부가 '실제로 팔렸는데 매입가가 없어 이익을 못 잡은 상품' 목록을 넘겨주면
        // 그것만 금액 큰 순으로 보여준다. 안 팔린 상품까지 전부 나오면 입력할 게 너무 많아진다.
        // 목록이 없으면(직접 들어온 경우) 매입가 미입력 상품 전체를 보여준다
        showNoPurchasePrice(handoff = null) {
            // 반품·박스훼손 재판매 SKU(skuGrade !== 'NEW')는 visibleInit() 에서 빠진다.
            // 이 등급은 PurchaseDB 문서가 아예 없는 경우가 많아 '매입가 없음' 의 상당수를 차지하는데,
            // 토글을 안 켜면 목록이 0건이 되어 "매입가 없는 상품이 없다" 로 보인다.
            // (실측 2026-08-20 hanbom: 판매장부 알림 9건이 전부 반품등급이라 화면엔 0건이었다)
            this.showReturnProducts = true;
            this.showlist = false;
            setTimeout(() => {
                const noPrice = e => {
                    const hasHistory = Array.isArray(e.매입정보) && e.매입정보.some(i => (i.매입가 || i.purchasePrice || 0) > 0);
                    return !hasHistory && !(e.매입가 > 0);
                };

                if (handoff && Array.isArray(handoff.items) && handoff.items.length) {
                    const impact = {};
                    handoff.items.forEach(i => { impact[String(i.vendorItemId)] = Number(i.contribution) || 0; });
                    this.productLists = this.visibleInit()
                        .filter(e => impact[String(e.vendorItemId)] !== undefined)
                        .sort((a, b) => (impact[String(b.vendorItemId)] || 0) - (impact[String(a.vendorItemId)] || 0));
                    this.noPurchasePriceNotice =
                        `판매장부에서 이익이 잡히지 않은 상품 ${this.productLists.length}개입니다. 금액이 큰 순서예요.`;
                } else {
                    this.productLists = this.visibleInit().filter(noPrice);
                    this.noPurchasePriceNotice =
                        `매입가가 입력되지 않은 상품 ${this.productLists.length}개입니다.`;
                }
                this.showlist = true;
            }, 1);
        },
        // 판매장부에서 '매입가 입력하러 가기'로 넘어왔는지 확인하고 적용한다.
        //
        // 헤더 탭(keep-alive)으로 상품관리가 이미 열려 있으면 데이터 로딩이 다시 돌지 않아
        // 목록 생성 시점의 검사만으로는 필터가 안 걸린다. 그래서 화면이 보일 때마다(activated)
        // 확인하고, 신호는 라우터 쿼리가 아니라 sessionStorage로 받는다
        // (탭 전환은 URL이 그대로일 수 있다).
        applyLedgerHandoff() {
            let handoff = null;
            try {
                const raw = sessionStorage.getItem('ledgerMissingPrice');
                if (raw) handoff = JSON.parse(raw);
            } catch (e) {
                console.warn('[상품DB] 판매장부 목록 읽기 실패', e.message);
            }
            if (!handoff) return;
            // 목록이 아직 없으면 로딩이 끝난 뒤 다시 불린다
            if (!this.visibleInit() || !this.visibleInit().length) return;
            this.showNoPurchasePrice(handoff);
            sessionStorage.removeItem('ledgerMissingPrice');
        },

        clearNoPurchasePriceFilter() {
            this.noPurchasePriceNotice = '';
            this.showtotal();
        },
        showProductIdChanged() {
            this.showlist = false;
            setTimeout(() => {
                const sevenDaysAgo = new Date();
                sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

                this.productLists = this.visibleInit().filter(e => {
                    if (!e.productIdHistory || e.productIdHistory.length === 0) return false;
                    return e.productIdHistory.some(history =>
                        new Date(history.date) >= sevenDaysAgo
                    );
                });
                this.showlist = true;
            }, 1);
        },
        showMatching() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.visibleInit().filter(e => {
                    return e.otherSellers && e.otherSellers.hasOtherSellers;
                });
                this.showlist = true;
            }, 1);
        },
        // 「아이템루저」 — 뱃지와 같은 판정식(isItemLoser)을 쓴다. 뱃지·필터·색상·엑셀·대시보드가
        // 모두 같은 기준이어야 숫자와 클릭 결과가 어긋나지 않는다.
        // 빈값/null(9,364건)은 '모름'이라 여기에도 안 들어온다.
        showa() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.visibleInit().filter(e => this.isItemLoser(e))
                this.showlist = true;
            }, 1);
        },
        // 「판매중지」·「품절」 — 아이템루저와 조치가 다르다. 루저는 경쟁에서 밀린 것이라
        // 가격·배송 조건을 손봐야 하고, 판매중지는 상태를 풀지 정해야 하고, 품절은 발주해야 한다.
        // 한 칸에 섞으면 지금 뭘 해야 하는지 알 수 없어서 따로 센다.
        //
        // 두 함수 모두 showReturnProducts 를 켠다. 뱃지는 productListsinit(반품등급 포함)
        // 기준으로 세는데 목록은 visibleInit() 이라 토글이 꺼져 있으면 반품등급 단독 행이 빠진다.
        // 그 행에 FILTERED_OUT 이 212건 있어 숫자와 표시가 어긋난다
        // (LOSER 는 0건이라 showa 는 이 문제가 없다). showe() 와 같은 처리다.
        showSaleSuspended() {
            this.showlist = false;
            this.showReturnProducts = true;
            setTimeout(() => {
                this.productLists = this.visibleInit().filter(e => this.isSaleSuspended(e))
                this.showlist = true;
            }, 1);
        },
        showSoldOut() {
            this.showlist = false;
            this.showReturnProducts = true;
            setTimeout(() => {
                this.productLists = this.visibleInit().filter(e => this.isSoldOut(e))
                this.showlist = true;
            }, 1);
        },
        showb() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.visibleInit().filter(e => !e.badge)
                this.showlist = true;
            }, 1);
        },
        showc() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.visibleInit().filter(e => e.구매정보여부)
                this.showlist = true;
            }, 1);
        },
        showd() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.visibleInit().filter(e => !e.구매정보여부)
                this.showlist = true;
            }, 1);
        },
        showe() {
            // 뱃지는 productListsinit(반품등급 포함) 기준으로 세는데 목록은 visibleInit() 기준이라
            // 반품등급 상품이 통째로 빠져 카운트와 표시가 어긋났다. showf() 와 같이 토글을 켜준다.
            this.showReturnProducts = true;
            this.showlist = false;
            setTimeout(() => {
                // 판정 기준도 뱃지(!e.매입가)와 맞춘다. 매입정보 행은 있는데 매입가가 비어 있는 상품이
                // 뱃지에는 세어지고 목록에는 안 나오던 차이를 없앤다.
                this.productLists = this.visibleInit().filter(e => !e.매입가)
                this.showlist = true;
            }, 1);
        },
        showf() {
            // "반품 보여줘" 는 의도가 명확하니 토글을 켜준다. 안 켜면 최상위 반품행이
            // visibleInit() 에서 걸러져 카운트(39)와 실제 표시(37)가 어긋난다.
            this.showReturnProducts = true;
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.visibleInit().filter(e => this.isReturnRow(e))
                this.showlist = true;
            }, 1);
        },
        showg() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.visibleInit().filter(e => e.upBundlingProducts && e.upBundlingProducts.length > 0)
                this.showlist = true;
            }, 1);
        },
        rematching(lists, list, index) {
            if (!list.구매링크) {
                alert('구매링크를 입력해 주세요')
                return
            }
            list.옵션1_중국어 = undefined;
            list.옵션2_중국어 = undefined;
            list.상품매칭.옵션1_중국어 = [];
            list.상품매칭.옵션2_중국어 = [];
            this.matchoption1(lists, index, list.구매링크)
        },
        async matchoption1(lists, index, 구매링크) {
            if (!구매링크.includes('1688.com')) {
                alert('올바른 구매링크를 입력해 주세요')
                lists[index].구매링크init = undefined;
                lists[index].구매링크 = undefined;
                return
            }
            lists[index].showspinner = true;
            lists[index].구매링크 = 구매링크;
            this.currentindex = index;
            // setTimeout(() => {this.sendmessage(구매링크);},1)
            var newObj = await this.confirmreq(lists[index]);
            // console.log(newObj)
            // this.showlist = false
            lists[index] = newObj;
            console.log(lists[this.currentindex])
            // this.showlist = true


            // axios.post('/api/reqpurchase/geturlinfo',{
            //     url : 구매링크
            // })
            // .then((res) => {
            //     if(res.data.요청결과 == 'success'){
            //         console.log(res.data.result)
            //         var obj = {}
            //         res.data.result.option1array.forEach(e => {
            //             obj = {
            //                 image : e.imageUrl,
            //                 optionname : e.name,
            //             }
            //             list.상품매칭.옵션1_중국어.push(obj)
            //         })
            //         res.data.result.option2array.forEach(e => {
            //             obj = {
            //                 image : e.imageUrl,
            //                 optionname : e.name,
            //             }
            //             list.상품매칭.옵션1_중국어.push(obj)
            //         })

            //     } else {
            //         alert('error777 :' + res.data.요청결과)
            //     }
            // })
            // .catch(console.log)
        },
        async confirmreq(obj) {
            console.log(obj)
            if (!obj.구매링크) {
                obj.showspinner = false;
                return obj
            }
            obj.구매링크init = obj.구매링크;
            obj.매칭상태 = '매칭필요'
            var item = await this.getProductInfo(obj.구매링크);
            item = item.data.result[0].result.result
            console.log(item)
            obj.item = item;

            let option1array = [];
            let option2array = [];

            if (item.productSkuInfos) {
                item.productSkuInfos.forEach((e) => {
                    if (!option1array.find(option => option.name === e.skuAttributes[0].value)) {
                        option1array.push({
                            name: e.skuAttributes[0].value,
                            imageUrl: e.skuAttributes[0].skuImageUrl ? e.skuAttributes[0].skuImageUrl : '',
                        })
                    }

                    if (e.skuAttributes[1]) {
                        if (!option2array.find(option => option.name === e.skuAttributes[1].value)) {
                            option2array.push({
                                name: e.skuAttributes[1].value,
                                imageUrl: e.skuAttributes[1].skuImageUrl ? e.skuAttributes[1].skuImageUrl : '',
                            })
                        }
                    } else {
                        option2array = []
                    }
                })
            }

            if (option1array.length === 0) {
                obj.상품매칭.옵션1_중국어 = [];
                obj.상품매칭.옵션2_중국어 = [];
                obj.옵션1_중국어 = '';
                obj.옵션2_중국어 = '';
                obj.구매재고 = item.productSaleInfo.amountOnSale;
                obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : item.productImage.images[0];
                obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : item.productImage.images[0];
                obj.매칭상태 = '매칭완료'
            } else {
                var imgUrl = '';
                if (option2array.length == 0) {
                    imgUrl = option1array.find(e => e.name == obj.옵션1_중국어) ? imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : "";
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어).amountOnSale;
                        obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : imgUrl;
                        obj.매칭상태 = '매칭완료'
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = [];
                    obj.옵션2_중국어 = '';
                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                } else {
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : option1array.find(e => e.name == obj.옵션1_중국어).imageUrl;
                        if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
                            obj.옵션2_중국어 = undefined;
                            obj.구매재고 = 0;
                        } else {
                            obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어 && f.skuAttributes[1].value == obj.옵션2_중국어).amountOnSale;
                            imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : "");
                            obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : (option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : ""));
                            obj.매칭상태 = '매칭완료'
                        }
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = option2array;
                    console.log(option1array)
                    console.log(option1array.find(e => e.name == obj.옵션1_중국어))
                    console.log(option2array)

                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                }

                if (!obj.등록이미지 && !option1array.find(e => e.imageUrl) && !option1array.find(e => e.imageUrl)) {
                    obj.등록이미지 = item.productImage.images[0];
                }
            }
            obj.showspinner = false;
            return obj
        },
        async getProductInfo(구매링크) {
            var productNo = 구매링크.slice(구매링크.search('offer/') + 6, 구매링크.search('.html'));
            try {
                var res = await axios.post('/api/aiPage/getProductInfo', [{ productId: parseInt(productNo) }])
                return res
            } catch (e) {
                console.log('err821' + e);
                return false
            }
        },
        pricechange(obj) {
            this.change = true;
            if (obj.매칭상태 == '매칭필요') {
                obj.구매가격 = '';
                return
            }
            if (obj.item && obj.구매요청수량) {
                var option1array = [];
                var option2array = [];
                var item = obj.item;
                if (item.props_list && Object.keys(item.props_list).length > 0) {
                    Object.keys(item.props_list).forEach(e => {
                        if (e[0] == '0') {
                            option1array.push({
                                properties: e,
                                name: item.props_list[e].split(":")[1],
                                imageUrl: item.props_img[e] ? item.props_img[e] : '',
                            })
                        }
                        if (e[0] == '1') {
                            option2array.push({
                                properties: e,
                                name: item.props_list[e].split(":")[1],
                                imageUrl: item.props_img[e] ? item.props_img[e] : '',
                            })
                        }
                    })
                }

                if (option1array.length == 0) {
                    if (item.priceRange) {
                        for (var i = 0; i < item.priceRange.length; i++) {
                            obj.구매가격 = parseFloat(item.priceRange[i][1]);
                            if (parseInt(item.priceRange[i][0]) > obj.구매요청수량) {
                                break
                            }
                        }
                    } else {
                        obj.구매가격 = parseInt(item.price);
                    }
                } else {
                    if (option2array.length == 0) {
                        if (item.priceRange) {
                            for (i = 0; i < item.priceRange.length; i++) {
                                obj.구매가격 = parseFloat(item.priceRange[i][1]);
                                if (parseInt(item.priceRange[i][0]) > obj.구매요청수량) {
                                    break
                                }
                            }
                        } else {
                            obj.구매가격 = parseInt(item.price);
                        }
                    } else {
                        if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                            obj.구매가격 = '';
                        } else {
                            if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
                                obj.구매가격 = '';
                            } else {
                                var option1properties = option1array.find(e => e.name == obj.옵션1_중국어).properties;
                                var option2properties = option2array.find(e => e.name == obj.옵션2_중국어).properties;
                                obj.구매가격 = parseInt(item.skus.sku.find(e => e.properties == (option1properties + ';' + option2properties)).price);
                            }
                        }
                    }
                }
            }
        },
        reset(list) {
            list.옵션1_중국어 = undefined;
            list.옵션2_중국어 = undefined;
            list.상품매칭.옵션1_중국어 = [];
            list.상품매칭.옵션2_중국어 = [];
            list.구매링크 = undefined;
            list.구매링크init = '';
        },
        deleteindexfromarray(array, index) {
            return array.slice(0, index).concat(array.slice(index + 1))
        },
        deleteitem(lists, index, f) {
            // this.showPurchase = false;
            lists.forEach(e => {
                e.묶음구성여부 = lists.length == 2 ? false : true;
                e.묶음구성수량 = lists.length == 2 ? "" : (lists.length - 1)
            })
            lists.splice(index, 1)
            console.log(lists)
            console.log(f)
            if (lists.length == 0) {
                console.log(lists.length)
                lists.push({
                    checked: false,
                    showspinner: false,
                    // SKUID : '',
                    바코드: f.바코드,
                    상품명: f.상품명,
                    상품명init: f.상품명,
                    구매링크: undefined,
                    구매링크init: undefined,
                    옵션1_중국어: undefined,
                    옵션2_중국어: undefined,
                    옵션이미지: undefined,
                    매칭상태: '매칭필요',
                    상품매칭: {
                        옵션1_중국어: [],
                        옵션2_중국어: [],
                    },
                    구매재고: '',
                    구매요청수량: '',
                    판매구성수량: 1,
                    묶음구성여부: false,
                    묶음구성수량: '',
                    묶음대상바코드: '',
                    신고영문명: '',
                    신고가격: '',
                    HSCODE: '',
                    진행현황: '구매전',
                    재고동봉: true,
                    등록이미지: f.옵션이미지,
                    요청사항: '요청등록',
                    reqtype: '제트배송',
                    sizeX: f.sizeX,
                    sizeY: f.sizeY,
                    sizeZ: f.sizeZ,
                    weight: f.weight,
                    요청내역: {
                        default: true,
                        poarrange: false,

                        한글표시사항: true,
                        barcode: true,
                        sticker: false,
                        sewing: false,
                        stamp: false,
                        tag: false,
                        reqcontent: '',
                        reqcontentPurchase: '',
                        opp: false,
                        LDPE: false,
                        airpacking: false,
                        exportType: 'box',
                        destination: 'coupang',
                        masking: false,
                        auto: true,
                        customsType: 'integrated'
                    },
                    한글표시사항: {
                        제품명: f.상품명,
                        '수입원/판매원': '',
                        제조원: '',
                        제조국: '',
                        내용량: '',
                        '원료명및성분명(재질)': '',
                        상품유형: '',
                        사용시주의사항: '',
                        사용기준: '',
                        custom: '',
                        kc인증: false,
                        식품용: false,
                    },
                    polists: [],
                    selectpo: '',
                })

            }
            console.log(lists)
            // lists = this.deleteindexfromarray(lists,index);
            // setTimeout(()=>{
            //     this.showPurchase = true;
            // },10)

        },
        matchclass(a) {
            if (a == '매칭완료') {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },
        reqclass(a) {
            if (a == '등록완료') {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },
        regclass(a) {
            if (a.length > 0) {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },
        option1matching(a, list) {
            // this.showlist = false;
            if (a.imageUrl) {
                // if(!list.등록이미지){
                list.등록이미지 = a.imageUrl;
                // }
                list.옵션이미지 = a.imageUrl;
            }
            list.옵션1_중국어 = a.name;


            // if(this.checkstock){
            if (list.옵션2_중국어 == '') {
                // var properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
                // list.구매재고 = parseInt(list.item.productSaleInfo.find(e => e.skuAttributes[0].옵션1_중국어 === list.옵션1_중국어).amountOnSale);
                list.item.productSkuInfos.forEach(e => {
                    if (e.skuAttributes[0].value === list.옵션1_중국어) {
                        list.구매재고 = e.amountOnSale
                    }
                })
                if (list.구매재고 == 0) {
                    alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                } else {
                    alert('구매 가능한 재고수량 : ' + list.구매재고)
                    list.매칭상태 = '매칭완료';
                }
            } else {
                if (list.옵션2_중국어 !== undefined) {
                    // properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
                    // var properties2 = list.상품매칭.옵션2_중국어.find(e => e.name == list.옵션2_중국어).properties;
                    // list.구매재고 = parseInt(list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).quantity);
                    // list.구매sku = list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).sku_id;
                    list.item.productSkuInfos.forEach(e => {
                        if (e.skuAttributes[0].value === list.옵션1_중국어 &&
                            e.skuAttributes[1].value === list.옵션2_중국어) {
                            list.구매재고 = e.amountOnSale
                        }
                    })
                    if (list.구매재고 == 0) {
                        alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                    } else {
                        alert('구매 가능한 재고수량 : ' + list.구매재고)
                        list.매칭상태 = '매칭완료';
                    }
                } else {
                    list.상품매칭.옵션2_중국어 = []
                    list.item.productSkuInfos.forEach(e => {
                        if (e.skuAttributes[0].value === list.옵션1_중국어) {
                            list.상품매칭.옵션2_중국어.push({
                                name: e.skuAttributes[1].value,
                                imageUrl: e.skuAttributes[1].skuImageUrl ? e.skuAttributes[1].skuImageUrl : '',
                            })
                        }
                    })
                }
            }
            // if(list.등록이미지 == '' && list.옵션이미지 == ''){
            //     list.등록이미지 = list.item.pic_url;
            //     list.옵션이미지 = list.item.pic_url;
            // }
            // this.showlist = true;
            // }
        },
        option2matching(a, list) {
            // this.showlist = false;
            if (a.imageUrl) {
                list.등록이미지 = a.imageUrl;
            }
            list.옵션2_중국어 = a.name;

            if (list.옵션1_중국어 !== undefined) {
                list.item.productSkuInfos.forEach(e => {
                    if (e.skuAttributes[0].value === list.옵션1_중국어 &&
                        e.skuAttributes[1].value === list.옵션2_중국어) {
                        list.구매재고 = e.amountOnSale
                    }
                })
                if (list.구매재고 == 0) {
                    alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                } else {
                    alert('구매 가능한 재고수량 : ' + list.구매재고)
                    list.매칭상태 = '매칭완료';
                }
            } else {
                list.상품매칭.옵션1_중국어 = []
                list.item.productSkuInfos.forEach(e => {
                    if (e.skuAttributes[1].value === list.옵션2_중국어) {
                        list.상품매칭.옵션1_중국어.push({
                            name: e.skuAttributes[0].value,
                            imageUrl: e.skuAttributes[0].skuImageUrl ? e.skuAttributes[0].skuImageUrl : '',
                        })
                    }
                })
            }

            // if(this.checkstock){

            // if(list.상품매칭.옵션1_중국어 && list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어)){
            //     var properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
            //     var properties2 = list.상품매칭.옵션2_중국어.find(e => e.name == list.옵션2_중국어).properties;
            //     list.구매재고 = parseInt(list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).quantity);
            //     list.구매sku = list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).sku_id;
            //     if(list.구매재고 == 0){
            //         alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
            //     } else {
            //         alert('구매 가능한 재고수량 : ' + list.구매재고)
            //     }
            //     list.매칭상태 = '매칭완료'
            // }
            //
            // // }
            // if(list.등록이미지 == '' && list.옵션이미지 == ''){
            //     list.등록이미지 = list.item.pic_url;
            //     list.옵션이미지 = list.item.pic_url;
            // }
            // this.showlist = true;
            console.log(list)
        },
        async uploadfile(event, matchType = 'vendorItemId') {
            try {
                this.showlist = false;
                console.log(this.$store.state.growthdb);
                this.showuploadspinner = true;
                this.currentUploadType = matchType;

                // 업로드 상태 업데이트
                if (matchType === 'barcode') {
                    this.uploadstatus2 = '업로드 중...';
                } else {
                    this.uploadstatus = '업로드 중...';
                }

                const file = event.target.files[0];
                const data = await this.readFileAsync(file);
                const workbook = XLSX.read(data, { type: 'binary' });

                for (const sheetName of workbook.SheetNames) {
                    const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                    console.log(roa);

                    let cntUpdate = 0;
                    const cnt = roa.length;
                    const errorArr = [];

                    for (const e of roa) {
                        let ob;

                        if (matchType === 'barcode') {
                            // 바코드로 매칭
                            if(!this.$store.state.growthdb || !this.$store.state.growthdb.find(ele => ele.barcode === e.바코드)){
                                errorArr.push(e.바코드);
                                continue;
                            }
                            ob = this.deepClone(
                                this.$store.state.growthdb.find(ele => ele.barcode === e.바코드)
                            );
                        } else {
                            // 옵션ID로 매칭
                            if(!this.$store.state.growthdb || !this.$store.state.growthdb.find(ele => ele.vendorItemId === e.옵션ID)){
                                errorArr.push(e.옵션ID);
                                continue;
                            }
                            ob = this.deepClone(
                                this.$store.state.growthdb.find(ele => ele.vendorItemId === e.옵션ID)
                            );
                        }

                        console.log(ob, e);

                        const date = this.excelDateToJSDate(e["매입일자(2025-01-01)"]);

                        // 스마트 업데이트: 동일 날짜가 있으면 덮어쓰기, 없으면 추가
                        if (ob.매입정보) {
                            const existingIndex = ob.매입정보.findIndex(info => info.date === date);
                            if (existingIndex >= 0) {
                                // 동일 날짜가 있으면 덮어쓰기
                                ob.매입정보[existingIndex].매입가 = e.매입가;
                            } else {
                                // 새로운 날짜면 추가
                                ob.매입정보.push({
                                    date: date,
                                    매입가: e.매입가,
                                });
                            }
                        } else {
                            ob.매입정보 = [{
                                date: date,
                                매입가: e.매입가,
                            }];
                        }

                        // 날짜순으로 정렬
                        ob.매입정보.sort((a, b) => new Date(a.date) - new Date(b.date));


                        this.changeCost(ob);
                        this.changeMargin(ob);

                        const success = await this.saveImportInfo(ob, false);
                        if (success) {
                            cntUpdate++;
                        } else {
                            errorArr.push(e.옵션ID);
                        }
                    }

                    // 결과 메시지 생성
                    const matchTypeText = matchType === 'barcode' ? '바코드' : '옵션ID';
                    if (cntUpdate === cnt) {
                        alert(`${matchTypeText} 매칭 업로드 완료: 성공 ${cntUpdate}개, 실패 0개`);
                    } else {
                        const failedCount = cnt - cntUpdate;
                        const failedList = errorArr.join(', ');
                        alert(`${matchTypeText} 매칭 업로드 완료: 성공 ${cntUpdate}개, 실패 ${failedCount}개\n실패한 ${matchTypeText}: ${failedList}\n(해당 ${matchTypeText}는 상품DB에 존재하지 않습니다.)`);
                    }

                    this.$store.commit('growthdbupdate', []);
                    this.showuploadspinner = false;
                    this.currentUploadType = '';

                    // 업로드 상태 초기화
                    if (matchType === 'barcode') {
                        this.uploadstatus2 = 'excel file upload';
                    } else {
                        this.uploadstatus = 'excel file upload';
                    }

                    // 매입정보 관리 데이터 새로고침
                    this.loadFlatImportInfos();
                    this.filterImportInfos();

                    this.search()
                }
            } catch (error) {
                alert(error.message);
                this.showuploadspinner = false;
                this.currentUploadType = '';

                // 업로드 상태 초기화
                if (matchType === 'barcode') {
                    this.uploadstatus2 = 'excel file upload';
                } else {
                    this.uploadstatus = 'excel file upload';
                }

                // 매입정보 관리 데이터 새로고침
                this.loadFlatImportInfos();
                this.filterImportInfos();
                this.search()
            }
        },
        async readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = (error) => reject(error);
                reader.readAsBinaryString(file);
            });
        },
        // winner 는 우리가 만드는 값이 아니라 쿠팡이 주는 buyboxStatus 원본값이다
        // (background.js:13021 = stockInfo.pricing.buyboxStatus).
        //   WINNER 50,600 / FILTERED_OUT 26,084 / LOSER 18,668 / 빈값·null 9,364 (2026-09-10)
        //
        // LOSER 와 FILTERED_OUT 은 **원인도 조치도 다르다.** 한 칸에 섞으면 지금 뭘
        // 해야 하는지 알 수가 없어서 지표를 나눠 둔다. 셋은 서로 겹치지 않는다.
        //   LOSER        = 경쟁에서 밀림 → 가격·배송 조건을 손본다   (isItemLoser)
        //   FILTERED_OUT = 판매중지      → 판매 상태를 풀지 결정한다 (isSaleSuspended)
        //                = 품절          → 발주·입고를 한다          (isSoldOut)
        //
        // 빈값/null 은 **모름**이다. 어느 쪽에도 세지 않는다.

        // 「아이템루저」의 유일한 판정식 — 뱃지·필터·엑셀·대시보드가 전부 이걸 쓴다.
        isItemLoser(item) {
            return !!item && item.winner === 'LOSER';
        },
        // ── FILTERED_OUT 을 「판매중지」와 「품절」로 가른다 ──────────────────────
        //
        // **순서가 중요하다. 판매중지가 품절보다 먼저다.**
        // 재고 0 은 판매중지의 *결과*일 수 있다 — 안 팔려고 재고를 비우고 판매중지를 건 상품을
        // 품절로 세면 사용자가 발주하러 갔다가 헛걸음한다. 조치가 정반대다.
        //   판매중지 → 판매 상태를 풀지 말지 결정   /   품절 → 발주·입고
        //
        // FILTERED_OUT 26,084건을 판매중지 × 재고로 가른 실측 (2026-09-10):
        //              재고 0             재고 있음        판정
        //   판매중지    25,089 (96.19%)     801 (3.07%)   → 「판매중지」 25,890 (99.26%)
        //   판매중         174 ( 0.67%)      20 (0.08%)   → 재고0 이면 「품절」 174 (0.67%)
        //                                                   재고 있으면 잔여 20 (0.08%)
        //   검산: 25,890 + 174 + 20 = 26,084 ✓
        //
        // 잔여 20건(판매중·재고있음·승인완료인데 FILTERED_OUT)은 어느 쪽도 아니다.
        // 품절로 세면 재고가 있는데 발주하라는 말이 되고, 판매중지로 세면 팔리는 걸 내리라는
        // 말이 된다. 둘 다 틀린 조치라 빈값/null 과 같이 '모름'으로 두고 세지 않는다.
        //
        // 왜 판매중지 판정에 validText 를 같이 보나:
        //   listingDetails.isSaleSuspended 는 934건에 **필드 자체가 없다**(구버전 수집분).
        //   그 934건은 쿠팡 원본 validText 가 100% '판매중지' 다. 필드만 보고 가르면 그중
        //   920건이 「품절」로 새어들어가 발주 헛걸음을 만든다.
        //   두 필드가 **둘 다 있는 문서에서는 100% 일치**한다(isSaleSuspended=false 194건 ↔
        //   validText='판매중' 194건). 같은 신호인데 validText 쪽 커버리지가 넓을 뿐이다.

        // 「판매중지」 — 1순위. 재고와 무관하다.
        isSaleSuspended(item) {
            if (!item || item.winner !== 'FILTERED_OUT') return false;
            return item.listingDetails?.isSaleSuspended === true || item.validText === '판매중지';
        },
        // 「품절」 — 2순위. 판매중지가 아니면서 재고가 0 인 것만. 판매중지와 겹치지 않는다.
        isSoldOut(item) {
            if (!item || item.winner !== 'FILTERED_OUT') return false;
            if (this.isSaleSuspended(item)) return false;
            return !(Number(item.orderableQuantity) > 0);
        },
        // 표 안의 '아이템위너' 칸 문구. 뱃지·필터와 같은 판정식을 쓴다 — 표시와 숫자가
        // 어긋나면 사용자가 뱃지를 눌러 놓고 왜 이 행이 여기 있냐고 묻게 된다.
        // FILTERED_OUT 중 어느 쪽도 아닌 20건은 '위너아님' — 원인을 우리 필드로는 알 수 없다.
        winnerLabel(item) {
            if (!item || item.winner !== 'FILTERED_OUT') return item ? item.winner : '';
            if (this.isSaleSuspended(item)) return '판매중지';
            if (this.isSoldOut(item)) return '품절';
            return '위너아님';
        },
        classWinner(winner) {
            if (winner == 'WINNER') {
                return 'success'
            } else if (winner == 'LOSER') {
                return 'secondary'
            } else {
                return 'danger'
            }
        }
    }
}
</script>
<style scoped>
::v-deep .my-dropdown-class {
    transform: translate3d(0px, -30px, 0px) !important;
    max-height: 150px;
    width: 400px;
    z-index: 9999;
    overflow-y: auto;
}

::v-deep .reqpo-modal-scrollable .modal-dialog {
    max-width: 90%;
    position: absolute;

    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

#quill-container {
    height: 50px;
}

#quill-container .ql-editor {
    min-height: unset;
}


.reqpo-action-button {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.reqpo-status {
    width: 100%;
    border: 3px solid #cccccc;
    display: flex;
    justify-content: space-between;
}

.reqpo-status-area {
    width: 30%;
    padding: 20px;
}

.reqpo-status-header {
    border-bottom: 1px solid #ccced2;
    text-align: center;
    margin-bottom: 12px;
}

.reqpo-status-tit {
    margin-bottom: 20px;
}

.reqpo-status-txt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.reqpo-status-txt a {
    cursor: pointer;
}

.reqpo-status-txt span {
    font-weight: bold;
}

.reqpo-purchase-request-form {
    padding: 1rem;
}

.reqpo-form-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
}

.reqpo-section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #dee2e6;
}

.reqpo-input-wrapper {
    margin-bottom: 1rem;
}

.reqpo-stock-info {
    font-size: 0.9rem;
    color: #6c757d;
}

.reqpo-info-label {
    color: #495057;
}

.reqpo-info-value {
    font-weight: 500;
    color: #212529;
}

.reqpo-separator {
    margin: 0 0.5rem;
    color: #adb5bd;
}

.reqpo-custom-radio-card {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.reqpo-custom-radio-card:hover {
    background: #e9ecef;
}

.reqpo-custom-radio-card.active {
    background: #e9ecef;
    border-color: #0d6efd;
}

.reqpo-card-title {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.reqpo-card-desc {
    font-size: 0.85rem;
    color: #6c757d;
}

.reqpo-warning-box {
    background: #fff3cd;
    border: 1px solid #ffeeba;
    border-radius: 6px;
    padding: 1rem;
}

.reqpo-warning-text {
    color: #dc3545;
    font-size: 0.85rem;
    margin-top: 0.25rem;
}

.reqpo-option-group {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.reqpo-option-title {
    font-weight: 500;
    color: #495057;
    font-size: 0.9rem;
}

.reqpo-text-muted {
    font-size: 0.85rem;
}
</style>
